webpackJsonp([1],{

/***/ 1023:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1039:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1040:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(67);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(68);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(17);

var _webpack = __webpack_require__(523);

var _webpack2 = _interopRequireDefault(_webpack);

var _styles = __webpack_require__(518);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Page, _Component);

  function Page() {
    (0, _classCallCheck3.default)(this, Page);
    return (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this));
  }

  (0, _createClass3.default)(Page, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var page = this.props.page;
      if (page) {
        console.log(page.getViewport);
        var scale = 150 / page.getViewport(1).height;
        var viewport = page.getViewport(scale);

        // Prepare canvas using PDF page dimensions
        var canvas = this.canvas;
        var context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        page.render({ canvasContext: context, viewport: viewport });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('canvas', {
        className: _styles2.default.page,
        ref: function ref(canvas) {
          _this2.canvas = canvas;
        }
      });
    }
  }]);
  return Page;
}(_react.Component)) || _class;

exports.default = Page;

/***/ }),

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayoutStore = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

var _mobx = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var bp = {
  sm: 768,
  md: 992,
  lg: 1200
};

var LayoutStore = exports.LayoutStore = (_class = function () {
  function LayoutStore() {
    (0, _classCallCheck3.default)(this, LayoutStore);

    _initDefineProp(this, 'sideBarOpen', _descriptor, this);

    _initDefineProp(this, 'screen', _descriptor2, this);

    _initDefineProp(this, 'handleResize', _descriptor3, this);

    _initDefineProp(this, 'toggleSideBarOpen', _descriptor4, this);

    window.addEventListener('resize', this.handleResize);

    this.screen = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  (0, _createClass3.default)(LayoutStore, [{
    key: 'breakpoint',
    get: function get() {
      var width = this.screen.width;
      var active = {};
      if (width < bp.sm) active.xs = true;
      if (width >= bp.sm) active.su = true;
      if (width >= bp.sm && width < bp.md) active.sm = true;
      if (width >= bp.md && width < bp.lg) active.md = true;
      if (width >= bp.md) active.mu = true;
      if (width >= bp.lg) active.lg = true;

      return active;
    }
  }, {
    key: 'sideBarDocked',
    get: function get() {
      return this.sideBarOpen && this.breakpoint.su;
    }
  }]);
  return LayoutStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'sideBarOpen', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'screen', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return { width: 0, height: 0 };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'breakpoint', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'breakpoint'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'sideBarDocked', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'sideBarDocked'), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'handleResize', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this = this;

    return function () {
      _this.screen.width = window.innerWidth;
      _this.screen.height = window.innerHeight;
      if (!_this.breakpoint.su && _this.sideBarOpen) {
        _this.toggleSideBarOpen();
      }
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'toggleSideBarOpen', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.sideBarOpen = !_this2.sideBarOpen;
    };
  }
})), _class);


var layoutStore = new LayoutStore();

exports.default = layoutStore;

/***/ }),

/***/ 1044:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2;

var _mobx = __webpack_require__(20);

var _page = __webpack_require__(1045);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RouteStore = (_class = function () {
  function RouteStore(routes) {
    var _this = this;

    (0, _classCallCheck3.default)(this, RouteStore);

    _initDefineProp(this, '_activeRoute', _descriptor, this);

    this._router = null;
    this._routes = [];

    _initDefineProp(this, 'setActive', _descriptor2, this);

    this._router = _page2.default;
    this._routes = routes;

    this._routes.forEach(function (route) {
      _this._router(route.pattern, function (_ref) {
        var params = _ref.params;
        return _this.setActive(route.pattern, params);
      });
    });

    this.navigate(window.location.pathname);
  }

  (0, _createClass3.default)(RouteStore, [{
    key: 'navigate',
    value: function navigate(route) {
      console.log('navigating to', route);
      this._router(route);
    }
  }, {
    key: 'activeRoute',
    get: function get() {
      var _this2 = this;

      var route = this._routes.find(function (route) {
        return route.pattern === _this2._activeRoute.pattern;
      });
      if (route) route.extra = this._activeRoute || {};
      return route;
    }
  }]);
  return RouteStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, '_activeRoute', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      pattern: null,
      params: null
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'activeRoute', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'activeRoute'), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'setActive', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (pattern, params) {
      _this3._activeRoute.pattern = pattern;
      _this3._activeRoute.params = params;
    };
  }
})), _class);
exports.default = RouteStore;

/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(1049);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

var _SideDrawer = __webpack_require__(1051);

var _SideDrawer2 = _interopRequireDefault(_SideDrawer);

var _AppBar = __webpack_require__(1057);

var _AppBar2 = _interopRequireDefault(_AppBar);

var _AppFooter = __webpack_require__(1068);

var _AppFooter2 = _interopRequireDefault(_AppFooter);

var _progress_bar = __webpack_require__(472);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _layout = __webpack_require__(1071);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function App(props) {
  var view = props.view,
      layout = props.layout;

  var title = "Lakrito";

  var renderRoute = function renderRoute() {
    // console.log('rendering...', view.currentRoute);
    if (view.loggingIn) return _react2.default.createElement(_progress_bar2.default, { type: 'circular', mode: 'indeterminate' });
    if (view.currentRoute) return view.currentRoute.main(view.currentRoute.extra);
    return null;
  };

  return _react2.default.createElement(
    _layout.Layout,
    null,
    _react2.default.createElement(
      _layout.NavDrawer,
      {
        theme: _styles2.default,
        active: layout.sideBarOpen,
        pinned: layout.sideBarDocked,
        onOverlayClick: layout.toggleSideBarOpen,
        premanentAt: 'lg'
      },
      _react2.default.createElement(_SideDrawer2.default, { title: title })
    ),
    _react2.default.createElement(
      _layout.Panel,
      { className: _styles2.default.content },
      _react2.default.createElement(_AppBar2.default, {
        title: title,
        toggleSidebar: layout.toggleSideBarOpen
      }),
      _react2.default.createElement(
        'section',
        null,
        renderRoute()
      ),
      _react2.default.createElement(_AppFooter2.default, null)
    )
  );
}

exports.default = (0, _mobxReact.inject)('view', 'layout')((0, _mobxReact.observer)(App));

/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1050);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, "/* @import \"react-toolbox/lib/variables.css\"; */\r\n\r\n/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n/* RT Appbar */\r\n\r\n/* RT Drawer */\r\n\r\n/* RT List */\r\n\r\n/* Footer */\r\n\r\n/* LAYOUT CSS */\r\n\r\n.styles--content--3UsUB4XO {\r\n  min-height: 100vh;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n}\r\n\r\n.styles--content--3UsUB4XO > section {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n  padding: 24px;\r\n}\r\n\r\n.styles--content--3UsUB4XO > footer {\r\n  height: 10rem;\r\n}\r\n\r\n/*\r\n.navDrawerDrawer {\r\n  background-color: var(--palette-grey-800) !important;\r\n  border: none !important;\r\n}\r\n*/\r\n", ""]);

// exports
exports.locals = {
	"content": "styles--content--3UsUB4XO"
};

/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(1052);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

var _routes = __webpack_require__(127);

var _routes2 = _interopRequireDefault(_routes);

var _ExpandableListItem = __webpack_require__(211);

var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);

var _list = __webpack_require__(136);

var _NavLink = __webpack_require__(1054);

var _NavLink2 = _interopRequireDefault(_NavLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SideDrawer(_ref) {
  var view = _ref.view,
      router = _ref.router,
      title = _ref.title;

  var renderMenu = function renderMenu() {
    if (!view.isLoggedIn || !view.isAuthenticated) return _react2.default.createElement('div', null);
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _list.List,
        { ripple: true },
        Object.keys(_routes2.default).map(function (key) {
          return _react2.default.createElement(
            _ExpandableListItem2.default,
            { key: key, title: key },
            _routes2.default[key].map(function (route) {
              return _react2.default.createElement(_NavLink2.default, { key: route.pattern, route: route });
            })
          );
        })
      )
    );
  };

  return _react2.default.createElement(
    'div',
    { className: _styles2.default.drawer },
    _react2.default.createElement(
      'div',
      {
        className: _styles2.default.drawerBrand,
        onClick: function onClick() {
          return router.navigate('/');
        }
      },
      title
    ),
    _react2.default.createElement('hr', { className: _styles2.default.divider }),
    renderMenu()
  );
}

exports.default = (0, _mobxReact.inject)('view', 'router')((0, _mobxReact.observer)(SideDrawer));

/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1053);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports
exports.i(__webpack_require__(215), undefined);
exports.i(__webpack_require__(535), undefined);

// module
exports.push([module.i, "/* @import \"react-toolbox/lib/variables.css\"; */\r\n\r\n/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n/* RT Appbar */\r\n\r\n/* RT Drawer */\r\n\r\n/* RT List */\r\n\r\n/* Footer */\r\n\r\n.styles--drawerBrand--qPKWzxLM {\r\n  height: 64px;\r\n  padding-left: 24px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.styles--drawer--38OuRXcA {\r\n  min-width: 240px;\r\n  height: 100vh;\r\n  z-index: 300;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.styles--divider--15-Vl7wb {\r\n  margin: 0;\r\n  border: 0;\r\n  border-top: 1px solid rgba(0, 0, 0, .2);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"drawerBrand": "styles--drawerBrand--qPKWzxLM " + __webpack_require__(215).locals["roman"] + " " + __webpack_require__(215).locals["large"] + "",
	"drawer": "styles--drawer--38OuRXcA " + __webpack_require__(535).locals["noUserSelect"] + "",
	"divider": "styles--divider--15-Vl7wb"
};

/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(1055);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

var _list = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {h} from 'preact';
function NavLink(_ref) {
  var view = _ref.view,
      route = _ref.route,
      router = _ref.router;

  return _react2.default.createElement(_list.ListItem, {
    theme: _styles2.default,
    className: view.currentRoute.pattern === route.pattern ? _styles2.default.active : null,
    selectable: true,
    caption: route.name,
    onClick: function onClick() {
      return router.navigate(route.pattern);
    }
  });
}

exports.default = (0, _mobxReact.inject)('view', 'router')((0, _mobxReact.observer)(NavLink));

/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1056);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, "/* @import \"react-toolbox/lib/variables.css\"; */\r\n\r\n/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n/* RT Appbar */\r\n\r\n/* RT Drawer */\r\n\r\n/* RT List */\r\n\r\n/* Footer */\r\n\r\n.styles--active--3sTe1ua1 {\r\n  background-color: rgb(238, 238, 238);\r\n}\r\n\r\n.styles--item--2ySjxE2J {\r\n  min-height: 48px;\r\n  padding-left: 36px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"active": "styles--active--3sTe1ua1",
	"item": "styles--item--2ySjxE2J"
};

/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(1058);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

var _app_bar = __webpack_require__(536);

var _menu = __webpack_require__(1062);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AppBar(_ref) {
  var view = _ref.view,
      title = _ref.title,
      toggleSidebar = _ref.toggleSidebar;


  var renderLogin = function renderLogin() {
    if (view.isLoggedIn) {
      return _react2.default.createElement(
        'div',
        null,
        view.currentUser.get('displayName')
      );
    } else {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          { onClick: function onClick() {
              return view.signIn();
            } },
          'login'
        )
      );
    }
  };

  var renderRightIcon = function renderRightIcon() {
    return _react2.default.createElement(
      _menu.IconMenu,
      { icon: 'more_vert', position: 'topLeft', menuRipple: true },
      _react2.default.createElement(_menu.MenuItem, { value: 'download', icon: 'get_app', caption: 'Download' }),
      _react2.default.createElement(_menu.MenuItem, { value: 'help', icon: 'favorite', caption: 'Favorite' }),
      _react2.default.createElement(_menu.MenuItem, { value: 'settings', icon: 'open_in_browser', caption: 'Open in app' }),
      _react2.default.createElement(_menu.MenuDivider, null),
      _react2.default.createElement(_menu.MenuItem, { value: 'signout', icon: 'delete', caption: 'Delete', disabled: true })
    );
  };

  var handleRightIconClick = function handleRightIconClick() {
    view.signOut();
  };

  return _react2.default.createElement(
    _app_bar.AppBar,
    {
      theme: _styles2.default,
      flat: true,
      title: title,
      leftIcon: 'menu',
      rightIcon: view.isLoggedIn ? "more_vert" : null,
      onLeftIconClick: toggleSidebar,
      onRightIconClick: handleRightIconClick
    },
    renderLogin()
  );
} // import {h} from 'preact';
exports.default = (0, _mobxReact.inject)('view')((0, _mobxReact.observer)(AppBar));

/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1059);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, "/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n\r\nheader.styles--appBar--1fs5Zu2q {\r\n  background-color: rgb(25, 118, 210);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"appBar": "styles--appBar--1fs5Zu2q"
};

/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(1069);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

var _link = __webpack_require__(495);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import {h} from 'preact';
function AppFooter(_ref) {
  var view = _ref.view;

  return _react2.default.createElement(
    'footer',
    { className: _styles2.default.footer },
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      null,
      'Made with \u2665 by ',
      _react2.default.createElement(
        'a',
        { className: _styles2.default.link, href: 'https://github.com/dev357', target: '_blank' },
        'dev357'
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      'view.loggingIn: ',
      JSON.stringify(view.loggingIn)
    )
  );
}

exports.default = (0, _mobxReact.inject)('view')((0, _mobxReact.observer)(AppFooter));

/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1070);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, "/* @import \"react-toolbox/lib/variables.css\"; */\r\n\r\n/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n/* RT Appbar */\r\n\r\n/* RT Drawer */\r\n\r\n/* RT List */\r\n\r\n/* Footer */\r\n\r\n.styles--footer--30bVOUO0 {\r\n  background-color: rgb(25, 118, 210);\r\n  color: rgb(255, 255, 255);\r\n  padding-left: 24px;\r\n}\r\n\r\n.styles--link--37JSuaOe {\r\n  color: rgb(255, 255, 255);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"footer": "styles--footer--30bVOUO0",
	"link": "styles--link--37JSuaOe"
};

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routesArray = exports.notAuthorisedRoute = exports.authenticateRoute = exports.notFoundRoute = exports.loginRoute = undefined;

var _toConsumableArray2 = __webpack_require__(807);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Kasumikalk = __webpack_require__(818);

var _Kasumikalk2 = _interopRequireDefault(_Kasumikalk);

var _NotFound = __webpack_require__(871);

var _NotFound2 = _interopRequireDefault(_NotFound);

var _NotAuthorised = __webpack_require__(875);

var _NotAuthorised2 = _interopRequireDefault(_NotAuthorised);

var _NotAuthenticated = __webpack_require__(879);

var _NotAuthenticated2 = _interopRequireDefault(_NotAuthenticated);

var _Login = __webpack_require__(883);

var _Login2 = _interopRequireDefault(_Login);

var _RouterTest = __webpack_require__(887);

var _RouterTest2 = _interopRequireDefault(_RouterTest);

var _Beeper = __webpack_require__(891);

var _Beeper2 = _interopRequireDefault(_Beeper);

var _SheetCalculator = __webpack_require__(976);

var _SheetCalculator2 = _interopRequireDefault(_SheetCalculator);

var _Imposer = __webpack_require__(993);

var _Imposer2 = _interopRequireDefault(_Imposer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = {
  Examples: [{
    name: 'Home',
    pattern: '/',
    main: function main() {
      return _react2.default.createElement(
        'div',
        null,
        'Home'
      );
    }
  }, {
    name: 'About',
    pattern: '/about',
    main: function main() {
      return _react2.default.createElement(
        'div',
        null,
        'About'
      );
    }
  }],
  Raha: [{
    access: ['admin'],
    name: 'Kasumikalk',
    pattern: '/kasumikalk',
    main: function main() {
      return _react2.default.createElement(_Kasumikalk2.default, null);
    }
  }],
  Test: [{
    name: 'RouterTest',
    pattern: '/test/:text',
    main: function main(extra) {
      return _react2.default.createElement(_RouterTest2.default, { extra: extra });
    }
  }],
  Lakrito: [{
    name: 'Piiksutaja',
    pattern: '/piiksutaja',
    access: ['developer', 'employee'],
    edit: ['beeperEditor'],
    main: function main() {
      return _react2.default.createElement(_Beeper2.default, null);
    }
  }, {
    name: 'Poogna Kalkulaator',
    pattern: '/sheetcalc',
    access: ['developer', 'tester'],
    main: function main() {
      return _react2.default.createElement(_SheetCalculator2.default, null);
    }
  }, {
    name: 'Imposer',
    pattern: '/imposer',
    access: ['developer'],
    main: function main() {
      return _react2.default.createElement(_Imposer2.default, null);
    }
  }]
};

var loginRoute = exports.loginRoute = {
  name: 'Login',
  main: function main() {
    return _react2.default.createElement(_Login2.default, null);
  }
};

var notFoundRoute = exports.notFoundRoute = {
  name: 'not-found',
  main: function main() {
    return _react2.default.createElement(_NotFound2.default, null);
  }
};

var authenticateRoute = exports.authenticateRoute = {
  name: 'not-authenticated',
  main: function main() {
    return _react2.default.createElement(_NotAuthenticated2.default, null);
  }
};

var notAuthorisedRoute = exports.notAuthorisedRoute = {
  name: 'not-authorised',
  main: function main() {
    return _react2.default.createElement(_NotAuthorised2.default, null);
  }
};

var routesArray = exports.routesArray = Object.keys(routes).reduce(function (acc, key) {
  return [].concat((0, _toConsumableArray3.default)(acc), (0, _toConsumableArray3.default)(routes[key]));
}, []);

exports.default = routes;

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

var _mobx = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Event = (_class = function Event(event) {
  (0, _classCallCheck3.default)(this, Event);

  _initDefineProp(this, 'event', _descriptor, this);

  _initDefineProp(this, 'id', _descriptor2, this);

  _initDefineProp(this, 'time', _descriptor3, this);

  _initDefineProp(this, 'editing', _descriptor4, this);

  _initDefineProp(this, 'personId', _descriptor5, this);

  _initDefineProp(this, 'setId', _descriptor6, this);

  _initDefineProp(this, 'setPersonId', _descriptor7, this);

  _initDefineProp(this, 'setEvent', _descriptor8, this);

  _initDefineProp(this, 'setEditing', _descriptor9, this);

  _initDefineProp(this, 'setTime', _descriptor10, this);

  this.setId(event.id);
  this.setPersonId(event.personId);
  this.setEvent(event.event);
  this.setTime(event.time);
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'event', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'time', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'editing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'personId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'setId', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this = this;

    return function (id) {
      _this.id = id;
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'setPersonId', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (personId) {
      _this2.personId = personId;
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'setEvent', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (event) {
      _this3.event = event;
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'setEditing', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (editing) {
      _this4.editing = editing || !_this4.editing;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'setTime', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (time) {
      if (time / 10000000000 > 1) {
        // time was in milliseconds, set it
        _this5.time = time;
      } else {
        // time was not in milliseconds, so multiply by 1000
        _this5.time = time * 1000;
      }
    };
  }
})), _class);
exports.default = Event;

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(67);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(68);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(953);

var _styles2 = _interopRequireDefault(_styles);

var _mobx = __webpack_require__(20);

var _mobxReact = __webpack_require__(17);

var _list = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ExpandableListItem = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(ExpandableListItem, _Component);

  function ExpandableListItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExpandableListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpandableListItem.__proto__ || Object.getPrototypeOf(ExpandableListItem)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isOpen', _descriptor, _this), _initDefineProp(_this, 'toggleOpen', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExpandableListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          children = _props.children,
          faulty = _props.faulty;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_list.ListItem, {
          theme: _styles2.default,
          className: faulty ? _styles2.default.faulty : null,
          selectable: true,
          caption: title,
          onClick: this.toggleOpen
        }),
        this.isOpen ? children : null
      );
    }
  }]);
  return ExpandableListItem;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isOpen', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'toggleOpen', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.isOpen = !_this2.isOpen;
    };
  }
})), _class2)) || _class;

exports.default = ExpandableListItem;

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.sheetTypeEnum = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

var _mobx = __webpack_require__(20);

var _localStorage = __webpack_require__(467);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _RendererStore = __webpack_require__(977);

var _RendererStore2 = _interopRequireDefault(_RendererStore);

var _WhiteSpaceStore = __webpack_require__(982);

var _WhiteSpaceStore2 = _interopRequireDefault(_WhiteSpaceStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var sheetTypeEnum = exports.sheetTypeEnum = {
  SHEETWISE: "P/S",
  WORK_AND_TURN: "Ü/V",
  WORK_AND_TUMBLE: "Ü/P"
};

var SheetCalculatorStore = (_class = function () {
  function SheetCalculatorStore() {
    var _desc2,
        _value2,
        _obj,
        _init,
        _init2,
        _init3,
        _init4,
        _init5,
        _init6,
        _this = this;

    (0, _classCallCheck3.default)(this, SheetCalculatorStore);
    this.rendererStore = null;
    this.store = (_obj = { sheet: {
        width: 640,
        height: 460,
        bottom: 15,
        top: 10,
        left: 3,
        right: 3
      },
      page: {
        width: 148,
        height: 210,
        amount: 2
      },
      bleed: {
        horizontal: '3',
        vertical: '3'
      },
      options: {
        type: sheetTypeEnum.SHEETWISE
      },
      settings: {
        brochure: {
          top: 'exactly|0',
          bottom: 'exactly|0',
          right: 'exactly|0',
          left: 'exactly|0'
        }
      },
      canvasWidth: 0
    }, (_applyDecoratedDescriptor(_obj, 'sheet', [_mobx.observable], (_init = Object.getOwnPropertyDescriptor(_obj, 'sheet'), _init = _init ? _init.value : undefined, {
      enumerable: true,
      configurable: true,
      writable: true,
      initializer: function initializer() {
        return _init;
      }
    }), _obj), _applyDecoratedDescriptor(_obj, 'page', [_mobx.observable], (_init2 = Object.getOwnPropertyDescriptor(_obj, 'page'), _init2 = _init2 ? _init2.value : undefined, {
      enumerable: true,
      configurable: true,
      writable: true,
      initializer: function initializer() {
        return _init2;
      }
    }), _obj), _applyDecoratedDescriptor(_obj, 'bleed', [_mobx.observable], (_init3 = Object.getOwnPropertyDescriptor(_obj, 'bleed'), _init3 = _init3 ? _init3.value : undefined, {
      enumerable: true,
      configurable: true,
      writable: true,
      initializer: function initializer() {
        return _init3;
      }
    }), _obj), _applyDecoratedDescriptor(_obj, 'options', [_mobx.observable], (_init4 = Object.getOwnPropertyDescriptor(_obj, 'options'), _init4 = _init4 ? _init4.value : undefined, {
      enumerable: true,
      configurable: true,
      writable: true,
      initializer: function initializer() {
        return _init4;
      }
    }), _obj), _applyDecoratedDescriptor(_obj, 'settings', [_mobx.observable], (_init5 = Object.getOwnPropertyDescriptor(_obj, 'settings'), _init5 = _init5 ? _init5.value : undefined, {
      enumerable: true,
      configurable: true,
      writable: true,
      initializer: function initializer() {
        return _init5;
      }
    }), _obj), _applyDecoratedDescriptor(_obj, 'canvasWidth', [_mobx.observable], (_init6 = Object.getOwnPropertyDescriptor(_obj, 'canvasWidth'), _init6 = _init6 ? _init6.value : undefined, {
      enumerable: true,
      configurable: true,
      writable: true,
      initializer: function initializer() {
        return _init6;
      }
    }), _obj)), _obj);
    this.brochureWhiteSpaces = {};

    this.fitsAxis = function (sheetWidth, pageWidth, bleeds, type) {
      if (pageWidth > sheetWidth) return 0;
      var currentWidth = pageWidth;
      var i = 1;
      while (currentWidth <= sheetWidth) {
        var bleedIndex = (i - 1) % bleeds.length;
        currentWidth += pageWidth + bleeds[bleedIndex];
        if (currentWidth <= sheetWidth) i++;
      }
      if (type && i % 2 !== 0) return i - 1;
      return i;
    };

    _initDefineProp(this, 'update', _descriptor, this);

    _initDefineProp(this, 'updateBleed', _descriptor2, this);

    _initDefineProp(this, 'updateCanvasWidth', _descriptor3, this);

    _initDefineProp(this, 'updateType', _descriptor4, this);

    this.load();
    this.persist();
    this.rendererStore = new _RendererStore2.default(this);
    Object.keys(this.store.settings.brochure).forEach(function (key) {
      _this.brochureWhiteSpaces[key] = new _WhiteSpaceStore2.default(_this.store.settings.brochure, key);
    });
  }

  (0, _createClass3.default)(SheetCalculatorStore, [{
    key: 'load',
    value: function load() {
      var _this2 = this;

      var stored = _localStorage2.default.get('SheetCalculatorStore') || {};
      console.log('got stored data', stored);
      Object.keys(stored).forEach(function (key) {
        return _this2.store[key] = stored[key];
      });
    }
  }, {
    key: 'persist',
    value: function persist() {
      var _this3 = this;

      (0, _mobx.autorun)(function () {
        _localStorage2.default.set('SheetCalculatorStore', _this3.toJson);
      });
    }
  }, {
    key: 'options',
    get: function get() {
      return {
        type: this.store.options.type
      };
    }
  }, {
    key: 'canvas',
    get: function get() {
      var canvasWidth = Math.min(this.store.canvasWidth, 800);
      return {
        width: canvasWidth,
        height: canvasWidth * this.sheet.height / this.sheet.width,
        scale: canvasWidth / this.store.sheet.width
      };
    }
  }, {
    key: 'sheet',
    get: function get() {
      return {
        width: this.store.sheet.width,
        height: this.store.sheet.height,
        bottom: this.store.sheet.bottom,
        top: this.store.sheet.top,
        left: this.store.sheet.left,
        right: this.store.sheet.right,
        area: this.store.sheet.width * this.store.sheet.height,
        printable: {
          width: this.store.sheet.width - this.store.sheet.left - this.store.sheet.right,
          height: this.store.sheet.height - this.store.sheet.bottom - this.store.sheet.top
        }
      };
    }
  }, {
    key: 'page',
    get: function get() {
      return {
        width: this.store.page.width,
        height: this.store.page.height,
        amount: this.store.page.amount,
        area: this.store.page.width * this.store.page.height
      };
    }
  }, {
    key: 'bleed',
    get: function get() {
      return {
        horizontal: this.store.bleed.horizontal,
        vertical: this.store.bleed.vertical,
        asArray: {
          horizontal: this.store.bleed.horizontal.split(',').map(function (val) {
            return parseInt(val) || 0;
          }),
          vertical: this.store.bleed.vertical.split(',').map(function (val) {
            return parseInt(val) || 0;
          })
        }
      };
    }
  }, {
    key: 'signature',
    get: function get() {
      var start = performance.now();

      var fits = this.fits;
      var page = this.page;
      var sheet = this.sheet;
      var bleeds = this.bleed.asArray;
      var options = this.store.options;
      var rotation = fits.type === 'upright' ? 0 : 90;
      var pages = [];

      var pageWidth = page.width;
      var pageHeight = page.height;
      if (rotation % 180 !== 0) {
        pageWidth = page.height;
        pageHeight = page.width;
      }

      var y = pageHeight / 2;
      var pageRotation = void 0;
      var pageNr = void 0;
      for (var i = 0; i < fits.vertical; i++) {
        var verticalBleedIndex = i % bleeds.vertical.length;
        var x = pageWidth / 2;
        for (var j = 0; j < fits.horizontal; j++) {
          pageRotation = rotation;
          pageNr = 1;
          if (options.type === sheetTypeEnum.WORK_AND_TURN) {
            if (j >= fits.horizontal / 2) {
              if (rotation % 180 !== 0) pageRotation = rotation + 180;
              if (page.amount >= 2) pageNr = 2;
            }
          } else if (options.type === sheetTypeEnum.WORK_AND_TUMBLE) {
            if (i < fits.vertical / 2) {
              if (rotation % 180 === 0) pageRotation = rotation + 180;
              if (page.amount >= 2) pageNr = 2;
            }
          }

          var horizontalBleedIndex = j % bleeds.horizontal.length;
          pages.push({
            x: x,
            y: y,
            rotation: pageRotation,
            pageNr: pageNr,
            width: page.width,
            height: page.height
          });
          x += pageWidth + bleeds.horizontal[horizontalBleedIndex];
        }
        y += pageHeight + bleeds.vertical[verticalBleedIndex];
      }

      var signatureWidth = pages[pages.length - 1].x + pageWidth / 2;
      var signatureHeight = pages[pages.length - 1].y + pageHeight / 2;

      var timeTaken = performance.now() - start;
      console.log('@computed signature took', timeTaken);

      return {
        pages: pages,
        width: signatureWidth,
        height: signatureHeight,
        x: (sheet.printable.width - signatureWidth) / 2 + sheet.left,
        y: (sheet.printable.height - signatureHeight) / 2 + sheet.top
      };
    }
  }, {
    key: 'fits',
    get: function get() {
      var workAndTurn = this.store.options.type === sheetTypeEnum.WORK_AND_TURN;
      var workAndTumble = this.store.options.type === sheetTypeEnum.WORK_AND_TUMBLE;
      var upright = {
        horizontal: this.fitsAxis(this.sheet.printable.width, this.page.width, this.bleed.asArray.horizontal, workAndTurn),
        vertical: this.fitsAxis(this.sheet.printable.height, this.page.height, this.bleed.asArray.vertical, workAndTumble)
      };
      var rotated = {
        horizontal: this.fitsAxis(this.sheet.printable.width, this.page.height, this.bleed.asArray.horizontal, workAndTurn),
        vertical: this.fitsAxis(this.sheet.printable.height, this.page.width, this.bleed.asArray.vertical, workAndTumble)
      };
      if (upright.horizontal * upright.vertical >= rotated.horizontal * rotated.vertical) {
        return {
          type: 'upright',
          horizontal: upright.horizontal,
          vertical: upright.vertical,
          total: upright.horizontal * upright.vertical
        };
      } else {
        return {
          type: 'rotated',
          horizontal: rotated.horizontal,
          vertical: rotated.vertical,
          total: rotated.horizontal * rotated.vertical
        };
      }
    }
  }, {
    key: 'toJson',
    get: function get() {
      return this.store;
    }
  }]);
  return SheetCalculatorStore;
}(), (_applyDecoratedDescriptor(_class.prototype, 'options', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'options'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'canvas', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'canvas'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'sheet', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'sheet'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'page', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'page'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bleed', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'bleed'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'signature', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'signature'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fits', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'fits'), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, 'update', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (observable, property, value) {
      // console.log(`updating ${observable}.${property} to ${parseInt(value)}`);
      _this4.store[observable][property] = parseInt(value);
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'updateBleed', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (property, value) {
      _this5.store.bleed[property] = value;
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'updateCanvasWidth', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (width) {
      _this6.store.canvasWidth = width;
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'updateType', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function (type) {
      _this7.store.options.type = type;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'load', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'load'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toJson', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'toJson'), _class.prototype)), _class);
exports.default = SheetCalculatorStore;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".type--text-thin--JoEtCVxk {\r\n  font-weight: 100;\r\n}\r\n\r\n.type--text-roman--1Esk5ogR {\r\n  font-weight: 400;\r\n}\r\n\r\n.type--text-bold--3Io0IrFu {\r\n  font-weight: 700;\r\n}\r\n\r\n.type--text-xsmall--2g0tzXOf {\r\n  font-size: 0.5rem;\r\n}\r\n\r\n.type--text-small--9bzsLSr0 {\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.type--text-medium--3G_IKkvq {\r\n  font-size: 1rem;\r\n}\r\n\r\n.type--text-large--qAirIA34 {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.type--text-xlarge--2l4vlNpz {\r\n  font-size: 3rem;\r\n}", ""]);

// exports
exports.locals = {
	"text-thin": "type--text-thin--JoEtCVxk",
	"text-roman": "type--text-roman--1Esk5ogR",
	"text-bold": "type--text-bold--3Io0IrFu",
	"text-xsmall": "type--text-xsmall--2g0tzXOf",
	"text-small": "type--text-small--9bzsLSr0",
	"text-medium": "type--text-medium--3G_IKkvq",
	"text-large": "type--text-large--qAirIA34",
	"text-xlarge": "type--text-xlarge--2l4vlNpz"
};

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firebaseRefs = exports.firebaseDb = exports.firebaseAuth = exports.firebaseApp = undefined;
exports.onAuthStateChanged = onAuthStateChanged;

var _firebase = __webpack_require__(415);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var firebaseApp = exports.firebaseApp = _firebase2.default.initializeApp({
  apiKey: {"FB_APIKEY":"AIzaSyDsD3rNFk_FfDsFDVVEgaYauNY7heFSNfo","FB_AUTHDOMAIN":"lakrito-printr.firebaseapp.com","FB_DATABASEURL":"https://lakrito-printr.firebaseio.com","FB_STORAGEBUCKET":"lakrito-printr.appspot.com"}.FB_APIKEY,
  authDomain: {"FB_APIKEY":"AIzaSyDsD3rNFk_FfDsFDVVEgaYauNY7heFSNfo","FB_AUTHDOMAIN":"lakrito-printr.firebaseapp.com","FB_DATABASEURL":"https://lakrito-printr.firebaseio.com","FB_STORAGEBUCKET":"lakrito-printr.appspot.com"}.FB_AUTHDOMAIN,
  databaseURL: {"FB_APIKEY":"AIzaSyDsD3rNFk_FfDsFDVVEgaYauNY7heFSNfo","FB_AUTHDOMAIN":"lakrito-printr.firebaseapp.com","FB_DATABASEURL":"https://lakrito-printr.firebaseio.com","FB_STORAGEBUCKET":"lakrito-printr.appspot.com"}.FB_DATABASEURL,
  storageBucket: {"FB_APIKEY":"AIzaSyDsD3rNFk_FfDsFDVVEgaYauNY7heFSNfo","FB_AUTHDOMAIN":"lakrito-printr.firebaseapp.com","FB_DATABASEURL":"https://lakrito-printr.firebaseio.com","FB_STORAGEBUCKET":"lakrito-printr.appspot.com"}.FB_STORAGEBUCKET
});
var firebaseAuth = exports.firebaseAuth = firebaseApp.auth();
var firebaseDb = exports.firebaseDb = firebaseApp.database();
var firebaseRefs = exports.firebaseRefs = {
  root: firebaseDb.ref(),
  users: firebaseDb.ref('users'),
  beeper: {
    events: firebaseDb.ref('beeper/events'),
    people: firebaseDb.ref('beeper/people')
  }
};
function onAuthStateChanged(callback) {
  firebaseAuth.onAuthStateChanged(function (user) {
    try {
      if (user) {
        var userUidRef = firebaseRefs.users.child(user.uid);
        var newUser = {};
        // get any extra options saved for that uid
        userUidRef.once('value', function (snap) {
          if (snap.val()) {
            // if the uid was found, (re)save some user details to users database
            userUidRef.update({
              email: user.email,
              displayName: user.displayName
            });
            // add extra info to the user object
            newUser.authenticated = true;
            newUser.groups = snap.val().groups;
          }
          newUser.uid = user.uid;
          newUser.photoURL = user.photoURL;
          newUser.displayName = user.displayName;
          newUser.email = user.email;

          callback(newUser);
        });
      } else {
        callback(user);
      }
    } catch (e) {
      console.error(e);
      throw e;
    }
  }, function (e) {
    console.error(e.message, e);
  });
}

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

var _mobx = __webpack_require__(20);

var _localStorage = __webpack_require__(467);

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var KasumikalkStore = (_class = function () {
  function KasumikalkStore() {
    (0, _classCallCheck3.default)(this, KasumikalkStore);

    _initDefineProp(this, 'numbers', _descriptor, this);

    _initDefineProp(this, 'updateWages', _descriptor2, this);

    _initDefineProp(this, 'updateRent', _descriptor3, this);

    _initDefineProp(this, 'updateKBA', _descriptor4, this);

    _initDefineProp(this, 'updateVersant', _descriptor5, this);

    _initDefineProp(this, 'updateHalm', _descriptor6, this);

    this.load();
    this.persist();
  }

  (0, _createClass3.default)(KasumikalkStore, [{
    key: 'load',
    value: function load() {
      var _this = this;

      var stored = _localStorage2.default.get('ProfitStore') || {};
      Object.keys(stored).forEach(function (key) {
        return _this.numbers[key] = stored[key];
      });
    }
  }, {
    key: 'persist',
    value: function persist() {
      var _this2 = this;

      (0, _mobx.autorun)(function () {
        _localStorage2.default.set('ProfitStore', _this2.toJson);
      });
    }
  }, {
    key: 'toJson',
    get: function get() {
      return this.numbers;
    }
  }, {
    key: 'wages',
    get: function get() {
      return this.numbers.wages;
    }
  }, {
    key: 'rent',
    get: function get() {
      return this.numbers.rent;
    }
  }, {
    key: 'kba',
    get: function get() {
      return this.numbers.kba;
    }
  }, {
    key: 'versant',
    get: function get() {
      return this.numbers.versant;
    }
  }, {
    key: 'halm',
    get: function get() {
      return this.numbers.halm;
    }
  }, {
    key: 'totalExpenses',
    get: function get() {
      return this.wages + this.rent;
    }
  }, {
    key: 'totalIncome',
    get: function get() {
      return this.kba + this.versant + this.halm;
    }
  }]);
  return KasumikalkStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'numbers', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      wages: 0,
      rent: 0,
      kba: 0,
      versant: 0,
      halm: 0
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'toJson', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'toJson'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'wages', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'wages'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'rent', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'rent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'kba', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'kba'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'versant', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'versant'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'halm', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'halm'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'totalExpenses', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'totalExpenses'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'totalIncome', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'totalIncome'), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'updateWages', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (wage) {
      return _this3.numbers.wages = parseInt(wage);
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'updateRent', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (rent) {
      return _this4.numbers.rent = parseInt(rent);
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'updateKBA', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (kba) {
      return _this5.numbers.kba = parseInt(kba);
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'updateVersant', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (versant) {
      return _this6.numbers.versant = parseInt(versant);
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'updateHalm', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function (halm) {
      return _this7.numbers.halm = parseInt(halm);
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'load', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'load'), _class.prototype)), _class);
exports.default = KasumikalkStore;

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  get: function get(k) {
    try {
      return JSON.parse(localStorage.getItem(k));
    } catch (e) {
      return null;
    }
  },
  set: function set(k, v) {
    localStorage.setItem(k, JSON.stringify(v));
  }
};

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(482);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;

var _mobx = __webpack_require__(20);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _FirebaseStore = __webpack_require__(455);

var _Event = __webpack_require__(205);

var _Event2 = _interopRequireDefault(_Event);

var _Person = __webpack_require__(896);

var _Person2 = _interopRequireDefault(_Person);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var beeperRef = _FirebaseStore.firebaseRefs.beeper;
var allPerson = { firstName: 'Kõik', lastName: 'Töötajad', key: 'no' };
var unknownPerson = { firstName: 'Tundmatu', lastName: 'Isik', key: 'no' };

var BeeperStore = (_class = function () {
  (0, _createClass3.default)(BeeperStore, [{
    key: 'activePersons',


    // returns an object with the selectedPerson as a key
    // If selectedPerson is 'all' returns a key for every person that had an event in the data
    get: function get() {
      var activePersons = [];
      if (this.selectedPerson && this.selectedPerson.id === 'all') {
        this.people.forEach(function (person) {

          if (person.events.length > 0) {
            activePersons.push(person);
          }
        });
      } else if (this.selectedPerson) {
        activePersons.push(this.selectedPerson);
      }
      return activePersons;
    }
  }, {
    key: 'peopleList',
    get: function get() {
      var peopleList = [];
      peopleList.push({ value: 'all', label: 'Kõik Töötajad' });
      peopleList.push({ value: 'unknown', label: 'Tundmatu' });
      this.people.forEach(function (person) {
        return peopleList.push({ value: person.id, label: person.fullName });
      });
      return peopleList;
    }
  }]);

  function BeeperStore(routeInfo) {
    (0, _classCallCheck3.default)(this, BeeperStore);

    _initDefineProp(this, 'people', _descriptor, this);

    _initDefineProp(this, 'selectedPerson', _descriptor2, this);

    _initDefineProp(this, 'events', _descriptor3, this);

    _initDefineProp(this, 'startDate', _descriptor4, this);

    _initDefineProp(this, 'endDate', _descriptor5, this);

    _initDefineProp(this, 'editableEvent', _descriptor6, this);

    _initDefineProp(this, 'editing', _descriptor7, this);

    this.routeInfo = null;

    _initDefineProp(this, 'setStartDate', _descriptor8, this);

    _initDefineProp(this, 'setEndDate', _descriptor9, this);

    _initDefineProp(this, 'setDates', _descriptor10, this);

    _initDefineProp(this, 'setSelectedPerson', _descriptor11, this);

    _initDefineProp(this, 'toggleEditing', _descriptor12, this);

    _initDefineProp(this, 'setEditableEvent', _descriptor13, this);

    this.convertToHours = function (time) {
      return '' + Math.floor(_moment2.default.duration(time).asHours()) + _moment2.default.utc(time).format(':mm:ss');
    };

    this.routeInfo = routeInfo;
    // console.log('created store');
  }

  (0, _createClass3.default)(BeeperStore, [{
    key: 'startListeners',
    value: function startListeners() {
      var _this = this;

      beeperRef.people.on('value', (0, _mobx.action)('addPeople', function (snapshot) {
        _this.people.clear();
        // this.addPerson('all', allPerson);
        // this.addPerson('unknown', unknownPerson);
        snapshot.forEach(function (snap) {
          _this.addPerson(snap.key, snap.val());
        });
      }));

      (0, _mobx.autorun)(function () {
        if (_this.startDate && _this.endDate) {
          console.log('getting events: ' + (0, _moment2.default)(_this.startDate).format('LL') + ' to ' + (0, _moment2.default)(_this.endDate).format('LL'));

          beeperRef.events.off();
          var beeperEvents = beeperRef.events.orderByChild('time').startAt(_this.startDate.getTime() / 1000).endAt(_this.endDate.getTime() / 1000);

          beeperEvents.once('value', function (snapshot) {
            var events = [];
            snapshot.forEach(function (snap) {
              events.push((0, _extends3.default)({ id: snap.key }, snap.val()));
            });
            _this.addEvents(events);

            beeperEvents.on('child_added', function (snap) {
              if (!_this.events.has(snap.key)) {
                console.log('child_added');
                _this.addEvent((0, _extends3.default)({ id: snap.key }, snap.val()));
              }
            });

            beeperEvents.on('child_removed', function (snap) {
              _this.removeEvent((0, _extends3.default)({ id: snap.key }, snap.val()));
            });

            beeperEvents.on('child_changed', function (snap) {
              _this.editEvent((0, _extends3.default)({ id: snap.key }, snap.val()));
            });
          });
        }
      });
    }
  }, {
    key: 'stopListeners',
    value: function stopListeners() {
      beeperRef.events.off();
      beeperRef.people.off();
    }
  }, {
    key: 'addEventToFB',
    value: function addEventToFB(event) {
      beeperRef.events.push(event);
    }
  }, {
    key: 'editEventInFB',
    value: function editEventInFB(id, event) {
      beeperRef.events.child(id).set(event);
    }
  }, {
    key: 'deleteEventFromFB',
    value: function deleteEventFromFB(id) {
      beeperRef.events.child(id).remove();
    }
  }, {
    key: 'addPerson',
    value: function addPerson(key, person) {
      this.people.set(key, new _Person2.default(key, person, this));
    }
  }, {
    key: 'removePerson',
    value: function removePerson(key) {
      this.people.delete(key);
    }
  }, {
    key: 'addEvent',
    value: function addEvent(event) {
      this.events.set(event.id, new _Event2.default(event));
    }
  }, {
    key: 'addEvents',
    value: function addEvents(events) {
      var _this2 = this;

      this.events.clear();
      events.forEach(function (event) {
        return _this2.addEvent(event);
      });
    }
  }, {
    key: 'editEvent',
    value: function editEvent(event) {
      console.log('editing event', event);
      this.addEvent(event);
    }
  }, {
    key: 'removeEvent',
    value: function removeEvent(event) {
      console.log('removing event', event);
      this.events.delete(event.id);
    }
  }]);
  return BeeperStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'people', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _mobx.observable.map({});
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'selectedPerson', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return { id: 'all' };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'events', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _mobx.observable.map({});
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'startDate', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return (0, _moment2.default)().startOf('day').toDate();
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'endDate', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return (0, _moment2.default)().endOf('day').toDate();
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'editableEvent', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'editing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'activePersons', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'activePersons'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'peopleList', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'peopleList'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addPerson', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'addPerson'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removePerson', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'removePerson'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addEvent', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'addEvent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addEvents', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'addEvents'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'editEvent', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'editEvent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeEvent', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'removeEvent'), _class.prototype), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'setStartDate', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (date) {
      _this3.startDate = date.toDate();
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'setEndDate', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (date) {
      _this4.endDate = date.toDate();
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'setDates', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (startDate, endDate) {
      _this5.setStartDate(startDate);
      _this5.setEndDate(endDate);
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'setSelectedPerson', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (person) {
      _this6.selectedPerson = person;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'toggleEditing', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function () {
      _this7.editing = !_this7.editing;
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'setEditableEvent', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this8 = this;

    return function (event) {
      _this8.editableEvent = new _Event2.default(event);
    };
  }
})), _class);
exports.default = BeeperStore;

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale_et = exports.locale_et = {
  months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
  monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
  weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
  weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
  weekdaysLetter: 'P_E_T_K_N_R_L'.split('_')
};

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(507);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(17);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _EventView = __webpack_require__(958);

var _EventView2 = _interopRequireDefault(_EventView);

var _Event = __webpack_require__(205);

var _Event2 = _interopRequireDefault(_Event);

var _EditEventView = __webpack_require__(508);

var _EditEventView2 = _interopRequireDefault(_EditEventView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EventView(_ref) {
  var _classnames;

  var event = _ref.event,
      store = _ref.store,
      view = _ref.view;

  var classNames = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, _EventView2.default.wrapper, true), (0, _defineProperty3.default)(_classnames, _EventView2.default.in, event.event === 'in'), (0, _defineProperty3.default)(_classnames, _EventView2.default.out, event.event === 'out'), _classnames));

  var handleEditEvent = function handleEditEvent() {
    if (!view.userHasGroup(store.routeInfo.edit)) return console.log('user not allowed to edit');
    store.setEditableEvent({
      id: event.id,
      personId: event.personId,
      event: event.event,
      time: event.time
    });
    store.toggleEditing();
  };

  return _react2.default.createElement(
    'div',
    {
      className: classNames,
      onClick: handleEditEvent
    },
    event.time ? (0, _moment2.default)(event.time).format('HH:mm:ss') : ''
  );
}

exports.default = (0, _mobxReact.inject)('view')((0, _mobxReact.observer)(EventView));

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(67);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(68);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(20);

var _mobxReact = __webpack_require__(17);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _locale = __webpack_require__(505);

var _Event = __webpack_require__(205);

var _Event2 = _interopRequireDefault(_Event);

var _dialog = __webpack_require__(209);

var _dialog2 = _interopRequireDefault(_dialog);

var _radio = __webpack_require__(960);

var _date_picker = __webpack_require__(483);

var _date_picker2 = _interopRequireDefault(_date_picker);

var _time_picker = __webpack_require__(964);

var _time_picker2 = _interopRequireDefault(_time_picker);

var _dropdown = __webpack_require__(504);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var EditEventView = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(EditEventView, _Component);

  function EditEventView() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EditEventView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditEventView.__proto__ || Object.getPrototypeOf(EditEventView)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'editingTime', _descriptor, _this), _initDefineProp(_this, 'toggleEditingTime', _descriptor2, _this), _this.handleToggle = function () {
      _this.props.store.toggleEditing();
    }, _this.handleEventChange = function (value) {
      _this.props.store.editableEvent.setEvent(value);
    }, _this.handlePersonChange = function (value) {
      var store = _this.props.store;
      console.log('value', value);
      _this.props.store.editableEvent.setPersonId(value);
      console.log('selectedPerson', store.editableEvent.personId);
    }, _this.handleDateChange = function (date) {
      _this.props.store.editableEvent.setTime(date.getTime());
      _this.toggleEditingTime();
    }, _this.handleTimeChange = function (time) {
      console.log('timechange');
      time.setSeconds(0);
      var t = new Date(_this.props.store.editableEvent.time);
      t.setHours(time.getHours());
      t.setMinutes(time.getMinutes());
      t.setSeconds(0);
      _this.props.store.editableEvent.setTime(t.getTime());
      _this.toggleEditingTime();
    }, _this.handleCreateNewEvent = function () {
      var event = _this.props.store.editableEvent;
      _this.props.store.addEventToFB({
        event: event.event,
        personId: event.personId,
        time: Math.floor(event.time / 1000)
      });
      _this.handleToggle();
    }, _this.handleEditEvent = function () {
      var event = _this.props.store.editableEvent;
      _this.props.store.editEventInFB(event.id, {
        event: event.event,
        personId: event.personId,
        time: Math.floor(event.time / 1000)
      });
      _this.handleToggle();
    }, _this.handleDeleteEvent = function () {
      _this.props.store.deleteEventFromFB(_this.props.store.editableEvent.id);
      _this.handleToggle();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EditEventView, [{
    key: 'render',
    value: function render() {
      var store = this.props.store;

      var event = store.editableEvent;
      var actions = [{ label: "Loobu", onClick: this.handleToggle }, { label: "Lisa", onClick: this.handleCreateNewEvent }];

      if (event.id) {
        actions.push({ label: "Muuda", onClick: this.handleEditEvent });
        actions.push({ label: "Kustuta", onClick: this.handleDeleteEvent });
      }

      return _react2.default.createElement(
        _dialog2.default,
        {
          actions: actions,
          active: store.editing,
          onEscKeyDown: this.handleToggle,
          onOverlayClick: this.handleToggle,
          title: 'DIALOGGGG!!',
          type: 'fullscreen'
        },
        _react2.default.createElement(_dropdown2.default, {
          auto: true,
          source: store.peopleList,
          onChange: this.handlePersonChange,
          value: store.editableEvent.personId || store.selectedPerson.id
        }),
        _react2.default.createElement(
          _radio.RadioGroup,
          {
            value: event.event,
            onChange: this.handleEventChange
          },
          _react2.default.createElement(_radio.RadioButton, { label: 'Sisse', value: 'in' }),
          _react2.default.createElement(_radio.RadioButton, { label: 'V\xE4lja', value: 'out' })
        ),
        _react2.default.createElement(_date_picker2.default, {
          label: 'Kuup\xE4ev',
          value: new Date(event.time),
          autoOk: true,
          locale: _locale.locale_et,
          maxDate: new Date(),
          onChange: this.handleDateChange,
          inputFormat: function inputFormat(value) {
            return '' + (0, _moment2.default)(value).format('LLLL');
          }
        }),
        _react2.default.createElement(
          'div',
          { hidden: true },
          _react2.default.createElement(_time_picker2.default, {
            active: this.editingTime,
            label: 'Kellaaeg',
            value: new Date(event.time),
            onChange: this.handleTimeChange
          })
        )
      );
    }
  }]);
  return EditEventView;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'editingTime', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'toggleEditingTime', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      return _this2.editingTime = !_this2.editingTime;
    };
  }
})), _class2)) || _class;

exports.default = EditEventView;

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(17);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _DayGraphView = __webpack_require__(971);

var _DayGraphView2 = _interopRequireDefault(_DayGraphView);

var _EventView = __webpack_require__(506);

var _EventView2 = _interopRequireDefault(_EventView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DayGraphView(_ref) {
  var store = _ref.store,
      day = _ref.day,
      person = _ref.person;

  var faulty = day.faulty;
  var dateText = '' + (0, _moment2.default)(day.time).format('LL') + (day.autoLunch ? '*' : '');

  var createGraph = function createGraph() {
    var graphs = [];
    var activeTime = day.time;

    // add the events
    day.events.forEach(function (event, i) {
      var styleName = event.event === 'in' ? _DayGraphView2.default.out : _DayGraphView2.default.in;
      var width = (event.time - activeTime) / 86400000 * 100;
      activeTime = event.time;
      graphs.push(_react2.default.createElement('div', { key: i, className: styleName, style: { width: width + '%' } }));
    });

    // add end of day to the end
    // if the day has not ended yet....
    if (day.events.length > 0) {
      if ((0, _moment2.default)(day.time).isSame((0, _moment2.default)(), 'day')) {
        var endWidth = (Date.now() - day.events[day.events.length - 1].time) / 86400000 * 100;
        graphs.push(_react2.default.createElement('div', { key: 'end', className: _DayGraphView2.default[day.events[day.events.length - 1].event], style: { width: endWidth + '%' } }));
      } else {
        var _endWidth = ((0, _moment2.default)(day.time).endOf('day') - day.events[day.events.length - 1].time) / 86400000 * 100;
        graphs.push(_react2.default.createElement('div', { key: 'end', className: _DayGraphView2.default.out, style: { width: _endWidth + '%' } }));
      }
    }

    return graphs;
  };

  var createDivider = function createDivider() {
    var parts = [];
    for (var i = 0; i < 24; i++) {
      parts.push(_react2.default.createElement('div', { key: i }));
    }
    return parts;
  };

  var createDetails = function createDetails() {
    return _react2.default.createElement(
      'div',
      null,
      person.eventsByStint(day.events).map(function (stint) {
        return _react2.default.createElement(
          'div',
          { className: _DayGraphView2.default.stint, key: stint.in.id || stint.out.id },
          _react2.default.createElement(_EventView2.default, { event: stint.in, store: store }),
          _react2.default.createElement(_EventView2.default, { event: stint.out, store: store }),
          _react2.default.createElement(
            'div',
            null,
            store.convertToHours(stint.length)
          )
        );
      })
    );
  };

  var handleViewClick = function handleViewClick() {
    day.toggleOpen();
  };

  console.log({ day: day });
  return _react2.default.createElement(
    'div',
    { className: _DayGraphView2.default.container },
    _react2.default.createElement(
      'div',
      {
        className: _DayGraphView2.default.wrapper,
        onClick: handleViewClick
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_DayGraphView2.default.dateWrapper, faulty ? _DayGraphView2.default.faulty : null) },
        _react2.default.createElement(
          'p',
          { className: _DayGraphView2.default.dateText },
          dateText
        ),
        _react2.default.createElement(
          'p',
          { className: _DayGraphView2.default.timeText },
          store.convertToHours(day.totalWorkTime)
        )
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_DayGraphView2.default.graphWrapper, faulty ? _DayGraphView2.default.blurred : false) },
        _react2.default.createElement(
          'div',
          { className: _DayGraphView2.default.graph },
          createGraph()
        ),
        _react2.default.createElement(
          'div',
          { className: _DayGraphView2.default.ruler },
          createDivider()
        )
      )
    ),
    day.open ? createDetails() : null
  );
}

exports.default = (0, _mobxReact.observer)(DayGraphView);

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(507);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _mobxReact = __webpack_require__(17);

var _SinglePersonView = __webpack_require__(974);

var _SinglePersonView2 = _interopRequireDefault(_SinglePersonView);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _DayGraphView = __webpack_require__(515);

var _DayGraphView2 = _interopRequireDefault(_DayGraphView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SinglePersonView(_ref) {
  var person = _ref.person,
      store = _ref.store;

  var eventsByDay = person.eventsByDay;

  var renderView = function renderView() {
    var _classnames;

    var faulty = eventsByDay.some(function (day) {
      return day.faulty;
    });
    var title = person.fullName + '\n          - ' + store.convertToHours(person.totalWorkTime) + '\n          (' + (0, _moment2.default)(store.startDate).format('DD.MM') + '\n          - ' + (0, _moment2.default)(store.endDate).format('DD.MM') + ')';

    var handleClick = function handleClick() {
      console.log('click');
      person.toggleOpen();
    };

    return _react2.default.createElement(
      'div',
      { className: _SinglePersonView2.default.wrapper },
      _react2.default.createElement(
        'p',
        {
          className: (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, _SinglePersonView2.default.faulty, faulty), (0, _defineProperty3.default)(_classnames, _SinglePersonView2.default.title, true), _classnames)),
          onClick: handleClick
        },
        title
      ),
      person.isOpen ? eventsByDay.map(function (day) {
        return _react2.default.createElement(_DayGraphView2.default, {
          key: day.time,
          day: day,
          person: person,
          store: store
        });
      }) : ''
    );
  };

  return renderView();
}

exports.default = (0, _mobxReact.observer)(SinglePersonView);

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(995);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ":root {\r\n  --appbar-height: 64px;\r\n  --sidedrawer-width: 10rem;\r\n  --footer-height: 160px;\r\n  --padding-left: 1.2rem;\r\n}\r\n\r\n.layout--noUserSelect--TDMRwUMn {\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"noUserSelect": "layout--noUserSelect--TDMRwUMn"
};

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(543);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(547);

var _mobx = __webpack_require__(20);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _mobxReact = __webpack_require__(17);

var _ViewStore = __webpack_require__(737);

var _ViewStore2 = _interopRequireDefault(_ViewStore);

var _LayoutStore = __webpack_require__(1043);

var _LayoutStore2 = _interopRequireDefault(_LayoutStore);

var _RouteStore = __webpack_require__(1044);

var _RouteStore2 = _interopRequireDefault(_RouteStore);

var _App = __webpack_require__(1048);

var _App2 = _interopRequireDefault(_App);

var _routes = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale('et');

(0, _mobx.useStrict)(true);

var router = new _RouteStore2.default(_routes.routesArray);
var viewStore = new _ViewStore2.default(router, _LayoutStore2.default);

var root = document.createElement('div');
root.id = 'app';
document.body.appendChild(root);

var DevTools = function DevTools() {
  return null;
};
if (false) DevTools = require('mobx-react-devtools').default;

(0, _reactDom.render)(_react2.default.createElement(
  _mobxReact.Provider,
  { view: viewStore, layout: _LayoutStore2.default, router: router },
  _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_App2.default, null),
    _react2.default.createElement(DevTools, { position: { bottom: 0, right: 20 } })
  )
), document.getElementById('app'));

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(544);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/lib/index.js!./main.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/lib/index.js!./main.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);

// module
exports.push([module.i, "/* @import \"react-toolbox/lib/colors.css\"; */\r\n/* @import \"react-toolbox/lib/variables.css\"; */\r\n/* RT Appbar */\r\n/* RT Drawer */\r\n/* RT List */\r\n/* Footer */\r\n/* @import \"react-toolbox/lib/media.css\"; */\r\n/* Orientation */\r\n/* Devices (defined by max width) */\r\n/* Devices (defined by min-width) */\r\n/*\r\n:global {\r\n  .material-icons {\r\n    line-height: inherit;\r\n  }\r\n}\r\n*/\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n", ""]);

// exports


/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 218,
	"./af.js": 218,
	"./ar": 219,
	"./ar-dz": 220,
	"./ar-dz.js": 220,
	"./ar-kw": 221,
	"./ar-kw.js": 221,
	"./ar-ly": 222,
	"./ar-ly.js": 222,
	"./ar-ma": 223,
	"./ar-ma.js": 223,
	"./ar-sa": 224,
	"./ar-sa.js": 224,
	"./ar-tn": 225,
	"./ar-tn.js": 225,
	"./ar.js": 219,
	"./az": 226,
	"./az.js": 226,
	"./be": 227,
	"./be.js": 227,
	"./bg": 228,
	"./bg.js": 228,
	"./bn": 229,
	"./bn.js": 229,
	"./bo": 230,
	"./bo.js": 230,
	"./br": 231,
	"./br.js": 231,
	"./bs": 232,
	"./bs.js": 232,
	"./ca": 233,
	"./ca.js": 233,
	"./cs": 234,
	"./cs.js": 234,
	"./cv": 235,
	"./cv.js": 235,
	"./cy": 236,
	"./cy.js": 236,
	"./da": 237,
	"./da.js": 237,
	"./de": 238,
	"./de-at": 239,
	"./de-at.js": 239,
	"./de-ch": 240,
	"./de-ch.js": 240,
	"./de.js": 238,
	"./dv": 241,
	"./dv.js": 241,
	"./el": 242,
	"./el.js": 242,
	"./en-au": 243,
	"./en-au.js": 243,
	"./en-ca": 244,
	"./en-ca.js": 244,
	"./en-gb": 245,
	"./en-gb.js": 245,
	"./en-ie": 246,
	"./en-ie.js": 246,
	"./en-nz": 247,
	"./en-nz.js": 247,
	"./eo": 248,
	"./eo.js": 248,
	"./es": 249,
	"./es-do": 250,
	"./es-do.js": 250,
	"./es.js": 249,
	"./et": 251,
	"./et.js": 251,
	"./eu": 252,
	"./eu.js": 252,
	"./fa": 253,
	"./fa.js": 253,
	"./fi": 254,
	"./fi.js": 254,
	"./fo": 255,
	"./fo.js": 255,
	"./fr": 256,
	"./fr-ca": 257,
	"./fr-ca.js": 257,
	"./fr-ch": 258,
	"./fr-ch.js": 258,
	"./fr.js": 256,
	"./fy": 259,
	"./fy.js": 259,
	"./gd": 260,
	"./gd.js": 260,
	"./gl": 261,
	"./gl.js": 261,
	"./gom-latn": 262,
	"./gom-latn.js": 262,
	"./he": 263,
	"./he.js": 263,
	"./hi": 264,
	"./hi.js": 264,
	"./hr": 265,
	"./hr.js": 265,
	"./hu": 266,
	"./hu.js": 266,
	"./hy-am": 267,
	"./hy-am.js": 267,
	"./id": 268,
	"./id.js": 268,
	"./is": 269,
	"./is.js": 269,
	"./it": 270,
	"./it.js": 270,
	"./ja": 271,
	"./ja.js": 271,
	"./jv": 272,
	"./jv.js": 272,
	"./ka": 273,
	"./ka.js": 273,
	"./kk": 274,
	"./kk.js": 274,
	"./km": 275,
	"./km.js": 275,
	"./kn": 276,
	"./kn.js": 276,
	"./ko": 277,
	"./ko.js": 277,
	"./ky": 278,
	"./ky.js": 278,
	"./lb": 279,
	"./lb.js": 279,
	"./lo": 280,
	"./lo.js": 280,
	"./lt": 281,
	"./lt.js": 281,
	"./lv": 282,
	"./lv.js": 282,
	"./me": 283,
	"./me.js": 283,
	"./mi": 284,
	"./mi.js": 284,
	"./mk": 285,
	"./mk.js": 285,
	"./ml": 286,
	"./ml.js": 286,
	"./mr": 287,
	"./mr.js": 287,
	"./ms": 288,
	"./ms-my": 289,
	"./ms-my.js": 289,
	"./ms.js": 288,
	"./my": 290,
	"./my.js": 290,
	"./nb": 291,
	"./nb.js": 291,
	"./ne": 292,
	"./ne.js": 292,
	"./nl": 293,
	"./nl-be": 294,
	"./nl-be.js": 294,
	"./nl.js": 293,
	"./nn": 295,
	"./nn.js": 295,
	"./pa-in": 296,
	"./pa-in.js": 296,
	"./pl": 297,
	"./pl.js": 297,
	"./pt": 298,
	"./pt-br": 299,
	"./pt-br.js": 299,
	"./pt.js": 298,
	"./ro": 300,
	"./ro.js": 300,
	"./ru": 301,
	"./ru.js": 301,
	"./sd": 302,
	"./sd.js": 302,
	"./se": 303,
	"./se.js": 303,
	"./si": 304,
	"./si.js": 304,
	"./sk": 305,
	"./sk.js": 305,
	"./sl": 306,
	"./sl.js": 306,
	"./sq": 307,
	"./sq.js": 307,
	"./sr": 308,
	"./sr-cyrl": 309,
	"./sr-cyrl.js": 309,
	"./sr.js": 308,
	"./ss": 310,
	"./ss.js": 310,
	"./sv": 311,
	"./sv.js": 311,
	"./sw": 312,
	"./sw.js": 312,
	"./ta": 313,
	"./ta.js": 313,
	"./te": 314,
	"./te.js": 314,
	"./tet": 315,
	"./tet.js": 315,
	"./th": 316,
	"./th.js": 316,
	"./tl-ph": 317,
	"./tl-ph.js": 317,
	"./tlh": 318,
	"./tlh.js": 318,
	"./tr": 319,
	"./tr.js": 319,
	"./tzl": 320,
	"./tzl.js": 320,
	"./tzm": 321,
	"./tzm-latn": 322,
	"./tzm-latn.js": 322,
	"./tzm.js": 321,
	"./uk": 323,
	"./uk.js": 323,
	"./ur": 324,
	"./ur.js": 324,
	"./uz": 325,
	"./uz-latn": 326,
	"./uz-latn.js": 326,
	"./uz.js": 325,
	"./vi": 327,
	"./vi.js": 327,
	"./x-pseudo": 328,
	"./x-pseudo.js": 328,
	"./yo": 329,
	"./yo.js": 329,
	"./zh-cn": 330,
	"./zh-cn.js": 330,
	"./zh-hk": 331,
	"./zh-hk.js": 331,
	"./zh-tw": 332,
	"./zh-tw.js": 332
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 546;

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

var _mobx = __webpack_require__(20);

var _firebase = __webpack_require__(415);

var _firebase2 = _interopRequireDefault(_firebase);

var _FirebaseStore = __webpack_require__(455);

var _routes = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var initialUser = {
  displayName: null,
  email: null,
  photoURL: null,
  uid: null,
  groups: {},
  authenticated: false
};

var ViewStore = (_class = function () {
  function ViewStore(router, layout) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ViewStore);

    _initDefineProp(this, 'loggingIn', _descriptor, this);

    _initDefineProp(this, 'currentUser', _descriptor2, this);

    this.router = null;
    this.layoutStore = null;

    _initDefineProp(this, 'setUser', _descriptor3, this);

    _initDefineProp(this, 'signIn', _descriptor4, this);

    _initDefineProp(this, 'signOut', _descriptor5, this);

    _initDefineProp(this, 'authenticate', _descriptor6, this);

    _initDefineProp(this, 'userHasGroup', _descriptor7, this);

    _initDefineProp(this, 'toggleSidebarOnNavigate', _descriptor8, this);

    this.router = router;
    this.layoutStore = layout;

    (0, _mobx.action)(function () {
      return _this.loggingIn = true;
    })();
    (0, _FirebaseStore.onAuthStateChanged)(this.setUser);

    // Close the Drawer when the route changes and the Drawer is not docked
    (0, _mobx.autorun)(function () {
      return _this.toggleSidebarOnNavigate(_this.router.activeRoute);
    });
  }

  (0, _createClass3.default)(ViewStore, [{
    key: 'currentRoute',
    get: function get() {
      if (!this.isLoggedIn) {
        return _routes.loginRoute;
      } else if (!this.isAuthenticated) {
        return _routes.authenticateRoute;
      } else if (!this.isAuthorised) {
        return _routes.notAuthorisedRoute;
      } else {
        return this.router.activeRoute || _routes.notFoundRoute;
      }
    }
  }, {
    key: 'isLoggedIn',
    get: function get() {
      return this.currentUser.has('uid');
    }
  }, {
    key: 'isAuthenticated',
    get: function get() {
      return this.currentUser.get('authenticated');
    }
  }, {
    key: 'isAuthorised',
    get: function get() {
      var route = this.router.activeRoute;

      // No matching route found, allow access to notFoundRoute
      if (!route) return true;

      // If route has no access restrictions, allow access
      if (!route.access) return true;

      if (this.currentUser.has('groups')) {
        var groups = this.currentUser.get('groups');

        // Allow any routes if the current user is a developer
        if (groups.developer) return true;

        // Allow access if user has the right group
        return !!route.access.find(function (item) {
          return item in groups;
        });
      }

      // None of the tests passed, dont authorise
      return false;
    }
  }]);
  return ViewStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'loggingIn', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'currentUser', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _mobx.observable.map({});
  }
}), _applyDecoratedDescriptor(_class.prototype, 'currentRoute', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'currentRoute'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isLoggedIn', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isLoggedIn'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isAuthenticated', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isAuthenticated'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isAuthorised', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isAuthorised'), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'setUser', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (user) {
      console.log('setUser', { user: user });
      _this2.loggingIn = false;
      user ? Object.keys(user).forEach(function (key) {
        return _this2.currentUser.set(key, user[key]);
      }) : _this2.currentUser.clear();
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'signIn', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function () {
      _this3.loggingIn = true;
      _this3.authenticate();
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'signOut', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    return function () {
      _FirebaseStore.firebaseAuth.signOut();
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'authenticate', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function () {
      _FirebaseStore.firebaseAuth.signInWithPopup(new _firebase2.default.auth.GoogleAuthProvider()).catch((0, _mobx.action)(function () {
        return _this4.loggingIn = false;
      }));
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'userHasGroup', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (groups) {
      return Object.keys(_this5.currentUser.get('groups')).some(function (group) {
        return groups.includes(group);
      });
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'toggleSidebarOnNavigate', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function () {
      if (!_this6.layoutStore.sideBarDocked && _this6.layoutStore.sideBarOpen) {
        _this6.layoutStore.toggleSideBarOpen();
      }
    };
  }
})), _class);
exports.default = ViewStore;

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.default = undefined;

var _KasumikalkStore = __webpack_require__(466);

Object.defineProperty(exports, 'store', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KasumikalkStore).default;
  }
});

var _Kasumikalk = __webpack_require__(819);

var _Kasumikalk2 = _interopRequireDefault(_Kasumikalk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Kasumikalk2.default;

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(67);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(68);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(17);

var _styles = __webpack_require__(841);

var _styles2 = _interopRequireDefault(_styles);

var _KasumikalkStore = __webpack_require__(466);

var _KasumikalkStore2 = _interopRequireDefault(_KasumikalkStore);

var _slider = __webpack_require__(843);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Kasumikalk = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Kasumikalk, _Component);

  function Kasumikalk() {
    (0, _classCallCheck3.default)(this, Kasumikalk);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Kasumikalk.__proto__ || Object.getPrototypeOf(Kasumikalk)).call(this));

    _this.store = null;

    _this.handleUpdateRent = function (value) {
      return _this.store.updateRent(value);
    };

    _this.handleUpdateWage = function (value) {
      return _this.store.updateWages(value);
    };

    _this.handleUpdateKBA = function (value) {
      return _this.store.updateKBA(value);
    };

    _this.handleUpdateVersant = function (value) {
      return _this.store.updateVersant(value);
    };

    _this.handleUpdateHalm = function (value) {
      return _this.store.updateHalm(value);
    };

    _this.store = new _KasumikalkStore2.default();
    return _this;
  }

  (0, _createClass3.default)(Kasumikalk, [{
    key: 'render',
    value: function render() {
      var store = this.store,
          handleUpdateHalm = this.handleUpdateHalm,
          handleUpdateKBA = this.handleUpdateKBA,
          handleUpdateRent = this.handleUpdateRent,
          handleUpdateVersant = this.handleUpdateVersant,
          handleUpdateWage = this.handleUpdateWage;

      return _react2.default.createElement(
        'form',
        { className: _styles2.default.form },
        _react2.default.createElement(
          'legend',
          null,
          'Kasumikalkulaator'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'fieldset',
            null,
            _react2.default.createElement(
              'legend',
              null,
              'Kulud'
            ),
            _react2.default.createElement(
              'div',
              { className: _styles2.default.sliderWrapper },
              _react2.default.createElement(
                'span',
                null,
                'Rent'
              ),
              _react2.default.createElement(_slider2.default, {
                theme: _styles2.default,
                value: store.rent,
                onChange: handleUpdateRent,
                min: 0,
                max: 10000,
                step: 1,
                editable: true,
                pinned: true
              })
            ),
            _react2.default.createElement(
              'span',
              null,
              'Palk'
            ),
            _react2.default.createElement(_slider2.default, { theme: _styles2.default, value: store.wages, onChange: handleUpdateWage, min: 0, max: 50000, step: 1, editable: true,
              pinned: true }),
            _react2.default.createElement(
              'span',
              null,
              'Kulud kokku: ',
              store.totalExpenses
            )
          ),
          _react2.default.createElement(
            'fieldset',
            null,
            _react2.default.createElement(
              'legend',
              null,
              'Tulud'
            ),
            _react2.default.createElement(
              'span',
              null,
              'KBA'
            ),
            _react2.default.createElement(_slider2.default, { theme: _styles2.default, value: store.kba, onChange: handleUpdateKBA, min: 0, max: 100000, step: 1, editable: true,
              pinned: true }),
            _react2.default.createElement(
              'span',
              null,
              'Versant'
            ),
            _react2.default.createElement(_slider2.default, { theme: _styles2.default, value: store.versant, onChange: handleUpdateVersant, min: 0, max: 100000, step: 1,
              editable: true, pinned: true }),
            _react2.default.createElement(
              'span',
              null,
              '\xDCmbrik'
            ),
            _react2.default.createElement(_slider2.default, { theme: _styles2.default, value: store.halm, onChange: handleUpdateHalm, min: 0, max: 100000, step: 1, editable: true,
              pinned: true }),
            _react2.default.createElement(
              'span',
              null,
              'Tulud kokku: ',
              store.totalIncome
            )
          )
        )
      );
    }
  }]);
  return Kasumikalk;
}(_react.Component)) || _class;

exports.default = Kasumikalk;

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(842);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".styles--form--1NSQqEjz > div {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: distribute;\r\n      justify-content: space-around;\r\n}\r\n\r\n.styles--form--1NSQqEjz > div > fieldset {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n}", ""]);

// exports
exports.locals = {
	"form": "styles--form--1NSQqEjz"
};

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _NotFound = __webpack_require__(872);

var _NotFound2 = _interopRequireDefault(_NotFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NotFound2.default;

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(873);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound() {
  return _react2.default.createElement(
    'div',
    { className: _styles2.default.notFound },
    _react2.default.createElement(
      'h1',
      null,
      '404 - Not Found'
    ),
    _react2.default.createElement(
      'p',
      null,
      '\u201CThese Are Not the Droids You Are Looking For\u201D'
    ),
    _react2.default.createElement(
      'i',
      { className: 'material-icons' },
      'adb'
    )
  );
}

exports.default = (0, _mobxReact.observer)(NotFound);

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(874);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".styles--notFound--763Wn4Zr {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  color: gray;\r\n}\r\n\r\n.styles--notFound--763Wn4Zr i {\r\n  font-size: 30rem;\r\n}\r\n\r\n.styles--notFound--763Wn4Zr h1 {\r\n  font-size: 3rem;\r\n  font-weight: bolder;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.styles--notFound--763Wn4Zr p {\r\n  font-size: 1.2rem;\r\n}", ""]);

// exports
exports.locals = {
	"notFound": "styles--notFound--763Wn4Zr"
};

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _NotAuthorised = __webpack_require__(876);

var _NotAuthorised2 = _interopRequireDefault(_NotAuthorised);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NotAuthorised2.default;

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(877);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotAuthorised() {
  return _react2.default.createElement(
    'div',
    { className: _styles2.default.notAuthorised },
    _react2.default.createElement(
      'h1',
      null,
      'ACCESS DENIED'
    ),
    _react2.default.createElement(
      'i',
      { className: 'material-icons' },
      'not_interested'
    )
  );
}

exports.default = (0, _mobxReact.observer)(NotAuthorised);

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(878);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".styles--notAuthorised--tEiiEaDD {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  color: gray;\r\n}\r\n\r\n.styles--notAuthorised--tEiiEaDD i {\r\n  font-size: 30rem;\r\n}\r\n\r\n.styles--notAuthorised--tEiiEaDD h1 {\r\n  font-size: 3rem;\r\n  font-weight: bolder;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.styles--notAuthorised--tEiiEaDD p {\r\n  font-size: 1.2rem;\r\n}", ""]);

// exports
exports.locals = {
	"notAuthorised": "styles--notAuthorised--tEiiEaDD"
};

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _NotAuthenticated = __webpack_require__(880);

var _NotAuthenticated2 = _interopRequireDefault(_NotAuthenticated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NotAuthenticated2.default;

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(881);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotAuthenticated() {
  return _react2.default.createElement(
    'div',
    { className: _styles2.default.notAuthenticated },
    _react2.default.createElement(
      'h1',
      null,
      'Logged in'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Please stand in line while we authenticate you'
    ),
    _react2.default.createElement(
      'i',
      { className: 'material-icons' },
      'group'
    )
  );
}

exports.default = (0, _mobxReact.observer)(NotAuthenticated);

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(882);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".styles--notAuthenticated--hhjNDgMQ {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  color: gray;\r\n}\r\n\r\n.styles--notAuthenticated--hhjNDgMQ i {\r\n  font-size: 30rem;\r\n}\r\n\r\n.styles--notAuthenticated--hhjNDgMQ h1 {\r\n  font-size: 3rem;\r\n  font-weight: bolder;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.styles--notAuthenticated--hhjNDgMQ p {\r\n  font-size: 1.2rem;\r\n}", ""]);

// exports
exports.locals = {
	"notAuthenticated": "styles--notAuthenticated--hhjNDgMQ"
};

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Login = __webpack_require__(884);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Login2.default;

/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(885);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Login(_ref) {
  var view = _ref.view;

  return _react2.default.createElement(
    'div',
    { className: _styles2.default.login },
    _react2.default.createElement(
      'h1',
      null,
      'Please LOG IN'
    ),
    _react2.default.createElement(
      'i',
      { onClick: function onClick() {
          return view.signIn();
        }, className: 'material-icons' },
      'account_box'
    )
  );
}

exports.default = (0, _mobxReact.inject)('view')((0, _mobxReact.observer)(Login));

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(886);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, "/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n\r\n.styles--login--3iT9Os4G {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  color: gray;\r\n}\r\n\r\n\r\n.styles--login--3iT9Os4G i {\r\n  font-size: 20rem;\r\n  cursor: pointer\r\n}\r\n\r\n\r\n.styles--login--3iT9Os4G i:hover {\r\n  color: rgb(25, 118, 210);\r\n}\r\n\r\n\r\n.styles--login--3iT9Os4G h1 {\r\n  font-size: 3rem;\r\n  font-weight: bolder;\r\n  margin-bottom: 0;\r\n}\r\n\r\n\r\n.styles--login--3iT9Os4G p {\r\n  font-size: 1.2rem;\r\n}", ""]);

// exports
exports.locals = {
	"login": "styles--login--3iT9Os4G"
};

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RouterTest = __webpack_require__(888);

var _RouterTest2 = _interopRequireDefault(_RouterTest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RouterTest2.default;

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(889);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RouterTest(_ref) {
  var _this = this;

  var extra = _ref.extra,
      router = _ref.router,
      view = _ref.view;

  return _react2.default.createElement(
    'div',
    { className: _styles2.default.routerTest },
    _react2.default.createElement(
      'h1',
      null,
      decodeURI(extra.params.text)
    ),
    _react2.default.createElement('input', {
      type: 'text',
      ref: function ref(input) {
        return _this.textInput = input;
      },
      placeholder: 'route param'
    }),
    _react2.default.createElement(
      'button',
      {
        onClick: function onClick() {
          return router.navigate('/test/' + _this.textInput.value);
        }
      },
      'Go'
    )
  );
}

exports.default = (0, _mobxReact.inject)('router', 'view')((0, _mobxReact.observer)(RouterTest));

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(890);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".styles--routerTest--8Hr4WSku {\r\n\r\n}\r\n", ""]);

// exports
exports.locals = {
	"routerTest": "styles--routerTest--8Hr4WSku"
};

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.default = undefined;

var _BeeperStore = __webpack_require__(481);

Object.defineProperty(exports, 'store', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BeeperStore).default;
  }
});

var _Beeper = __webpack_require__(898);

var _Beeper2 = _interopRequireDefault(_Beeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Beeper2.default;

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(482);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

var _mobx = __webpack_require__(20);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _Day = __webpack_require__(897);

var _Day2 = _interopRequireDefault(_Day);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var LUNCHBREAK_LENGTH = 1000 * 60 * 30; // 30 minutes
var MAX_WORKDAY_LENGTH = 1000 * 60 * 60 * 18; // 18 hours
var MAX_WITHOUT_LUNCH = 1000 * 60 * 60 * 8; // 8 hours

var Person = (_class = function () {
  function Person(id, person, store) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Person);

    _initDefineProp(this, 'firstName', _descriptor, this);

    _initDefineProp(this, 'lastName', _descriptor2, this);

    _initDefineProp(this, 'id', _descriptor3, this);

    _initDefineProp(this, 'key', _descriptor4, this);

    _initDefineProp(this, 'isOpen', _descriptor5, this);

    this.store = null;

    _initDefineProp(this, 'setOpen', _descriptor6, this);

    _initDefineProp(this, 'toggleOpen', _descriptor7, this);

    this.verifyDays = function (days) {
      for (var i = 0; i < days.length; i++) {
        var day = days[i];
        day.totalWorkTime = 0;
        var nextDay = days[i + 1];

        var inEvent = {};
        var prevEvent = {};
        for (var j = 0; j < day.events.length; j++) {
          var event = day.events[j];

          if (event.event === 'in') {
            inEvent = event;

            if (j !== 0 && prevEvent.event !== 'out') day.faulty = true;

            // if the last event of the day was an in, check the first event of the next day
            if (j === day.events.length - 1) {
              if (nextDay) {
                var nextEvent = nextDay.events[0];
                if (nextEvent && nextEvent.event === 'out') {
                  var workTime = _this.calcWorkTime(inEvent, nextEvent, day);
                  if (workTime) {
                    // this out should be in this day, move the event here
                    day.addEvent(nextEvent);
                    nextDay.removeEventAt(0);
                    prevEvent = event;
                    continue;
                  }
                }
              }

              // if the day of the last in event has not ended, dont mark as faulty
              if ((0, _moment2.default)(event.time).isSame((0, _moment2.default)(), 'day')) {
                var _workTime = _this.calcWorkTime(inEvent, { time: Date.now() }, day);
                _workTime ? day.totalWorkTime += _workTime : day.faulty = true;
                continue;
              }

              day.faulty = true;
            }
          }

          if (event.event === 'out') {
            if (prevEvent.event !== 'in') {
              day.faulty = true;
            } else {
              var _workTime2 = _this.calcWorkTime(inEvent, event, day);
              _workTime2 ? day.totalWorkTime += _workTime2 : day.faulty = true;
            }
          }
          prevEvent = event;
        }
      }
    };

    this.calcWorkTime = function (inEvent, outEvent, day) {
      if (!inEvent || !outEvent) return false;
      var workTime = outEvent.time - inEvent.time;

      // everything is OK, add to totalWorkTime
      if (workTime < MAX_WITHOUT_LUNCH) return workTime;

      // probably forgot lunch, deduct LUNCHBREAK
      if (workTime < MAX_WORKDAY_LENGTH) {
        day.autoLunch = true;
        return workTime - LUNCHBREAK_LENGTH;
      }

      // time difference too long, dont add time, set day faulty
      console.log('workTime too long', workTime, _moment2.default.duration(workTime).asHours(), (0, _moment2.default)(outEvent.time).format('LL'));
      return false;
    };

    this.eventsByStint = function (events) {
      var stints = [];
      var stint = { in: {}, out: {}, length: 0 };
      var lastStint = stint;
      events.forEach(function (event) {
        if (event.event === 'in') {
          lastStint = (0, _extends3.default)({}, stint, { in: event });
          stints.push(lastStint);
        } else if (event.event === 'out') {
          if (lastStint.in.event) {
            lastStint.out = event;
            lastStint.length = lastStint.out.time - lastStint.in.time;
          } else {
            stints.push((0, _extends3.default)({}, stint, { out: event }));
          }
          lastStint = stint;
        }
      });
      return stints;
    };

    this.store = store;
    this.id = id;
    this.firstName = person.firstName;
    this.lastName = person.lastName;
    this.key = person.key;
  }

  (0, _createClass3.default)(Person, [{
    key: 'events',
    get: function get() {
      var _this2 = this;

      var events = [];
      this.store.events.forEach(function (event) {
        if (_this2.id === event.personId) {
          events.push(event);
        }
      });
      // return array sorted by time
      return events.sort(function (event1, event2) {
        return event1.time - event2.time;
      });
    }
  }, {
    key: 'fullName',
    get: function get() {
      return this.firstName + ' ' + this.lastName;
    }
  }, {
    key: 'eventsByDay',
    get: function get() {
      var days = [];
      this.events.forEach(function (event) {
        var time = (0, _moment2.default)(event.time).startOf('day').valueOf();
        var day = days.find(function (day) {
          return day.time === time;
        });
        if (!day) {
          day = new _Day2.default(time);
          days.push(day);
        }
        day.addEvent(event);
      });
      this.verifyDays(days);
      return days;
    }
  }, {
    key: 'totalWorkTime',
    get: function get() {
      return this.eventsByDay.reduce(function (acc, day) {
        return acc + day.totalWorkTime;
      }, 0);
    }

    // Checks if the events in a day make sense

  }]);
  return Person;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'firstName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'lastName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'key', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'isOpen', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'events', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'events'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fullName', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'fullName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'eventsByDay', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'eventsByDay'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'totalWorkTime', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'totalWorkTime'), _class.prototype), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'setOpen', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (open) {
      _this3.isOpen = open;
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'toggleOpen', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function () {
      _this4.isOpen = !_this4.isOpen;
    };
  }
})), _class);
exports.default = Person;

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

var _mobx = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Day = (_class = function () {
  function Day(time) {
    (0, _classCallCheck3.default)(this, Day);

    _initDefineProp(this, 'events', _descriptor, this);

    _initDefineProp(this, 'time', _descriptor2, this);

    _initDefineProp(this, 'open', _descriptor3, this);

    this.person = null;

    this.time = time;
  }

  (0, _createClass3.default)(Day, [{
    key: 'addEvent',
    value: function addEvent(event) {
      this.events.push(event);
    }
  }, {
    key: 'removeEventAt',
    value: function removeEventAt(index) {
      this.events.splice(index, 1);
    }
  }, {
    key: 'toggleOpen',
    value: function toggleOpen() {
      this.open = !this.open;
    }
  }]);
  return Day;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'events', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'time', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'open', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'addEvent', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'addEvent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeEventAt', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'removeEventAt'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleOpen', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'toggleOpen'), _class.prototype)), _class);
exports.default = Day;

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(67);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(68);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(899);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _date_picker = __webpack_require__(483);

var _date_picker2 = _interopRequireDefault(_date_picker);

var _autocomplete = __webpack_require__(927);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _navigation = __webpack_require__(936);

var _navigation2 = _interopRequireDefault(_navigation);

var _list = __webpack_require__(136);

var _dropdown = __webpack_require__(504);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _locale = __webpack_require__(505);

var _BeeperStore = __webpack_require__(481);

var _BeeperStore2 = _interopRequireDefault(_BeeperStore);

var _routes = __webpack_require__(127);

var _routes2 = _interopRequireDefault(_routes);

var _ExpandableListItem = __webpack_require__(211);

var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);

var _DayView = __webpack_require__(955);

var _DayView2 = _interopRequireDefault(_DayView);

var _DayGraphView = __webpack_require__(515);

var _DayGraphView2 = _interopRequireDefault(_DayGraphView);

var _MultiPersonView = __webpack_require__(973);

var _MultiPersonView2 = _interopRequireDefault(_MultiPersonView);

var _SinglePersonView = __webpack_require__(516);

var _SinglePersonView2 = _interopRequireDefault(_SinglePersonView);

var _EditEventView = __webpack_require__(508);

var _EditEventView2 = _interopRequireDefault(_EditEventView);

var _checkbox = __webpack_require__(496);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Beeper = (_dec = (0, _mobxReact.inject)("view"), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Beeper, _Component);

  function Beeper() {
    (0, _classCallCheck3.default)(this, Beeper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Beeper.__proto__ || Object.getPrototypeOf(Beeper)).call(this));

    _this.store = null;

    _this.handlePersonChange = function (personId) {
      if (personId === 'all') {
        _this.store.setSelectedPerson({ id: 'all' });
      } else {
        _this.store.setSelectedPerson(_this.store.people.get(personId));
      }
    };

    _this.handleAddNewEvent = function () {
      _this.store.setEditableEvent({
        personId: _this.store.selectedPerson && _this.store.selectedPerson.id || null,
        event: null,
        time: new Date().getTime()
      });
      _this.store.toggleEditing();
    };

    _this.renderData = function () {
      var store = _this.store;

      // don't render anything if some of the data is missing
      if (!store.startDate || !store.endDate || !store.selectedPerson) return _react2.default.createElement(
        'div',
        null,
        'Please fill the inputs'
      );

      // render single day view - is this needed?
      // if (m(store.startDate).isSame(m(store.endDate), 'day')) return <DayGraphView store={store}/>;

      // render multi person view
      if (store.selectedPerson.id === 'all') return _react2.default.createElement(_MultiPersonView2.default, { persons: store.activePersons, store: store });

      // render single person view
      if (store.selectedPerson) {
        store.selectedPerson.setOpen(true);
        return _react2.default.createElement(_SinglePersonView2.default, { person: store.selectedPerson, store: store });
      }

      return null;
    };

    _this.store = new _BeeperStore2.default(_routes2.default.Lakrito[0]);
    return _this;
  }

  (0, _createClass3.default)(Beeper, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.store.startListeners();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.stopListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var store = this.store;
      var view = this.props.view;


      var actions = [{ label: 'Täna', onClick: function onClick() {
          return store.setDates((0, _moment2.default)().startOf('day'), (0, _moment2.default)().endOf('day'));
        } }, { label: 'Eile', onClick: function onClick() {
          return store.setDates((0, _moment2.default)().subtract(1, 'day').startOf('day'), (0, _moment2.default)().subtract(1, 'day').endOf('day'));
        } }, { label: 'See Kuu', onClick: function onClick() {
          return store.setDates((0, _moment2.default)().startOf('month'), (0, _moment2.default)().endOf('day'));
        } }, { label: 'Eelmine Kuu', onClick: function onClick() {
          return store.setDates((0, _moment2.default)().subtract(1, 'month').startOf('month'), (0, _moment2.default)().subtract(1, 'month').endOf('month'));
        } }];

      if (view.userHasGroup(store.routeInfo.edit)) actions.push({ label: 'Lisa Sündmus', onClick: function onClick() {
          return _this2.handleAddNewEvent();
        } });

      return _react2.default.createElement(
        'div',
        { className: _styles2.default.beeper },
        _react2.default.createElement(_navigation2.default, { type: 'horizontal', actions: actions }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_dropdown2.default, {
            auto: true,
            allowBlank: false,
            source: store.peopleList,
            onChange: this.handlePersonChange,
            value: store.selectedPerson && store.selectedPerson.id
          }),
          _react2.default.createElement(_date_picker2.default, {
            label: 'algus',
            value: store.startDate,
            autoOk: true,
            locale: _locale.locale_et,
            maxDate: new Date(),
            onChange: function onChange(date) {
              return store.setStartDate((0, _moment2.default)(date).startOf('day'));
            },
            inputFormat: function inputFormat(value) {
              return '' + (0, _moment2.default)(value).format('LL');
            }
          }),
          _react2.default.createElement(_date_picker2.default, {
            label: 'l\xF5pp',
            value: store.endDate,
            autoOk: true,
            locale: _locale.locale_et,
            maxDate: new Date(),
            onChange: function onChange(date) {
              return store.setEndDate((0, _moment2.default)(date).endOf('day'));
            },
            inputFormat: function inputFormat(value) {
              return '' + (0, _moment2.default)(value).format('LL');
            }
          })
        ),
        _react2.default.createElement(
          _list.List,
          null,
          this.renderData()
        ),
        _react2.default.createElement(_EditEventView2.default, {
          store: store
        })
      );
    }
  }]);
  return Beeper;
}(_react.Component)) || _class) || _class);
exports.default = Beeper;

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(900);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".styles--beeper--1rLbdO3E {\r\n\r\n}\r\n\r\n.styles--autocomplete--2kHSGPzf {\r\n  padding: 0;\r\n}\r\n\r\n.styles--in--22GP8fTW {\r\n  color: green;\r\n}\r\n\r\n.styles--out--snHyA6ju {\r\n  color: red;\r\n}\r\n\r\n.styles--faulty--2Vx365UU {\r\n  color: darkmagenta;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"beeper": "styles--beeper--1rLbdO3E",
	"autocomplete": "styles--autocomplete--2kHSGPzf",
	"in": "styles--in--22GP8fTW",
	"out": "styles--out--snHyA6ju",
	"faulty": "styles--faulty--2Vx365UU"
};

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(954);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, "/* @import \"react-toolbox/lib/variables.css\"; */\r\n\r\n/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n/* RT Appbar */\r\n\r\n/* RT Drawer */\r\n\r\n/* RT List */\r\n\r\n/* Footer */\r\n\r\n.styles--item--3YnXOJqD {\r\n  min-height: 48px;\r\n  padding-left: 24px;\r\n}\r\n\r\n.styles--itemText--3M2btfMY.styles--primary--2Y5xxt17 {\r\n  @extend .text-bold;\r\n}\r\n\r\n.styles--faulty--2WArlGfS .styles--primary--2Y5xxt17 {\r\n  color: red;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"item": "styles--item--3YnXOJqD",
	"itemText": "styles--itemText--3M2btfMY",
	"primary": "styles--primary--2Y5xxt17",
	"faulty": "styles--faulty--2WArlGfS"
};

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _mobxReact = __webpack_require__(17);

var _DayView = __webpack_require__(956);

var _DayView2 = _interopRequireDefault(_DayView);

var _EventView = __webpack_require__(506);

var _EventView2 = _interopRequireDefault(_EventView);

var _ExpandableListItem = __webpack_require__(211);

var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DayView(_ref) {
  var store = _ref.store,
      day = _ref.day,
      person = _ref.person;

  var title = (0, _moment2.default)(day.time).format('LL') + '\n    - ' + store.convertToHours(day.totalWorkTime) + '\n    (' + (0, _moment2.default)(day.events[0].time).format('HH:mm') + '\n    - ' + (0, _moment2.default)(day.events[day.events.length - 1].time).format('HH:mm') + ')' + (day.autoLunch ? '*' : '');
  return _react2.default.createElement(
    'div',
    { className: _DayView2.default.test },
    _react2.default.createElement(
      _ExpandableListItem2.default,
      {
        faulty: day.faulty,
        title: title
      },
      person.eventsByStint(day.events).map(function (stint) {
        return _react2.default.createElement(
          'div',
          { className: _DayView2.default.stint, key: stint.in.id || stint.out.id },
          _react2.default.createElement(_EventView2.default, { event: stint.in, store: store }),
          _react2.default.createElement(_EventView2.default, { event: stint.out, store: store }),
          _react2.default.createElement(
            'div',
            null,
            store.convertToHours(stint.length)
          )
        );
      })
    )
  );
}

exports.default = (0, _mobxReact.observer)(DayView);

// {day.events.map(event => (
//   <EventView
//     key={event.id}
//     event={event}
//     store={store}
//   />
// ))}

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(957);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js!./DayView.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js!./DayView.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, "/* @import \"react-toolbox/lib/variables.css\"; */\r\n\r\n/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n/* RT Appbar */\r\n\r\n/* RT Drawer */\r\n\r\n/* RT List */\r\n\r\n/* Footer */\r\n\r\n.DayView--stint--2NyAqhFW {\r\n  margin-left: 24px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n}\r\n\r\n.DayView--stint--2NyAqhFW > * {\r\n  margin-right: 2rem;\r\n  width: 7rem;\r\n}\r\n\r\n.DayView--test--2M-SAwsP {\r\n  text-indent: 1rem;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"stint": "DayView--stint--2NyAqhFW",
	"test": "DayView--test--2M-SAwsP"
};

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(959);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js!./EventView.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js!./EventView.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".EventView--in--3k9mOVT3 {\r\n  color: green;\r\n}\r\n\r\n.EventView--out--3nQRKQNU {\r\n  color: red;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"in": "EventView--in--3k9mOVT3",
	"out": "EventView--out--3nQRKQNU"
};

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(972);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js!./DayGraphView.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js!./DayGraphView.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, "/* @import \"react-toolbox/lib/variables.css\"; */\r\n\r\n/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n/* RT Appbar */\r\n\r\n/* RT Drawer */\r\n\r\n/* RT List */\r\n\r\n/* Footer */\r\n\r\n.DayGraphView--container--34jpUs9E {\r\n  margin-bottom: 0.2rem;\r\n}\r\n\r\n.DayGraphView--wrapper--3KT6xliU {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n}\r\n\r\n.DayGraphView--dateWrapper--3lffiluH {\r\n  width: 15rem;\r\n  -webkit-box-align: end;\r\n      -ms-flex-align: end;\r\n          align-items: flex-end;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  margin-right: 1rem;\r\n}\r\n\r\n.DayGraphView--graphWrapper--v1K3VVyf {\r\n  width: 100%;\r\n  position: relative;\r\n  height: 4rem;\r\n}\r\n\r\n.DayGraphView--graph--1_8ZHcuw, .DayGraphView--ruler--2G4VJCLg {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  overflow: hidden;\r\n}\r\n\r\n.DayGraphView--graph--1_8ZHcuw {\r\n  background-color: black;\r\n}\r\n\r\n.DayGraphView--ruler--2G4VJCLg {\r\n  height: 10%;\r\n}\r\n\r\n.DayGraphView--ruler--2G4VJCLg > * {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex-positive: 1;\r\n          flex-grow: 1;\r\n  border-left: 1px solid black;\r\n}\r\n\r\n.DayGraphView--ruler--2G4VJCLg *:first-child {\r\n  border: none;\r\n}\r\n\r\n.DayGraphView--in--1j9t9ieh {\r\n  background-color: green;\r\n}\r\n\r\n.DayGraphView--out--1SV0VfH4 {\r\n  background-color: red;\r\n}\r\n\r\n.DayGraphView--faulty--3tapHjkv {\r\n  color: red;\r\n}\r\n\r\n.DayGraphView--blurred--3Gb5wafi {\r\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.37007999999999996 0.57216 0.057760000000000006 0 0 0.17008 0.77216 0.057760000000000006 0 0 0.17008 0.57216 0.25775999999999993 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2\" /><feFuncG type=\"linear\" slope=\"2\" /><feFuncB type=\"linear\" slope=\"2\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.5\" intercept=\"0.25\" /><feFuncG type=\"linear\" slope=\"0.5\" intercept=\"0.25\" /><feFuncB type=\"linear\" slope=\"0.5\" intercept=\"0.25\" /></feComponentTransfer><feGaussianBlur stdDeviation=\"1\" /></filter></svg>#filter');\r\n  -webkit-filter: grayscale(80%) brightness(200%) contrast(50%) blur(1px);\r\n          filter: grayscale(80%) brightness(200%) contrast(50%) blur(1px);\r\n}\r\n\r\n.DayGraphView--stint--Tlb8Vf78 {\r\n  margin-left: 24px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n}\r\n\r\n.DayGraphView--stint--Tlb8Vf78 > * {\r\n  margin-right: 2rem;\r\n  width: 7rem;\r\n}\r\n\r\n.DayGraphView--timeText--1oRQ7F7g {\r\n  font-size: 1rem;\r\n  line-height: 1.4rem;\r\n}\r\n\r\n.DayGraphView--dateText--1DaZ5Uig {\r\n  line-height: 1.4rem;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "DayGraphView--container--34jpUs9E",
	"wrapper": "DayGraphView--wrapper--3KT6xliU",
	"dateWrapper": "DayGraphView--dateWrapper--3lffiluH",
	"graphWrapper": "DayGraphView--graphWrapper--v1K3VVyf",
	"graph": "DayGraphView--graph--1_8ZHcuw",
	"ruler": "DayGraphView--ruler--2G4VJCLg",
	"in": "DayGraphView--in--1j9t9ieh",
	"out": "DayGraphView--out--1SV0VfH4",
	"faulty": "DayGraphView--faulty--3tapHjkv",
	"blurred": "DayGraphView--blurred--3Gb5wafi",
	"stint": "DayGraphView--stint--Tlb8Vf78",
	"timeText": "DayGraphView--timeText--1oRQ7F7g",
	"dateText": "DayGraphView--dateText--1DaZ5Uig"
};

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(17);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _SinglePersonView = __webpack_require__(516);

var _SinglePersonView2 = _interopRequireDefault(_SinglePersonView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MultiPersonView(_ref) {
  var persons = _ref.persons,
      store = _ref.store;

  var isSameDay = (0, _moment2.default)(store.startDate).isSame((0, _moment2.default)(store.endDate), 'day');
  if (isSameDay) {
    persons.map(function (person) {
      return person.setOpen(true);
    });
  } else {
    persons.map(function (person) {
      return person.setOpen(false);
    });
  }

  return _react2.default.createElement(
    'div',
    null,
    persons.map(function (person) {
      return _react2.default.createElement(_SinglePersonView2.default, {
        key: person.id,
        person: person,
        store: store
      });
    })
  );
}

exports.default = (0, _mobxReact.observer)(MultiPersonView);

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(975);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js!./SinglePersonView.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js!./SinglePersonView.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".SinglePersonView--title--ePzWxInO {\r\n  padding: 1rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.SinglePersonView--title--ePzWxInO:hover {\r\n  background-color: lightgray;\r\n}\r\n\r\n.SinglePersonView--faulty--2E0DOL59 {\r\n  color: red;\r\n}", ""]);

// exports
exports.locals = {
	"title": "SinglePersonView--title--ePzWxInO",
	"faulty": "SinglePersonView--faulty--2E0DOL59"
};

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.default = undefined;

var _SheetCalculatorStore = __webpack_require__(212);

Object.defineProperty(exports, 'store', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetCalculatorStore).default;
  }
});

var _SheetCalculator = __webpack_require__(983);

var _SheetCalculator2 = _interopRequireDefault(_SheetCalculator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SheetCalculator2.default;

/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _mobx = __webpack_require__(20);

var _Sheet = __webpack_require__(978);

var _Sheet2 = _interopRequireDefault(_Sheet);

var _Page = __webpack_require__(980);

var _Page2 = _interopRequireDefault(_Page);

var _pageGraphics = __webpack_require__(981);

var _pageGraphics2 = _interopRequireDefault(_pageGraphics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PAGE_COLOR = 0xFFE673;
var PAGE_HOVER_COLOR = 0xAA9539;
var PAGE_TEXT_COLOR = 0x000000;

var RendererStore = function () {
  function RendererStore(store) {
    var _this = this;

    (0, _classCallCheck3.default)(this, RendererStore);
    this.store = null;
    this.container = null;
    this.pagesContainer = new PIXI.Container();
    this.pageTextures = {};
    this.renderer = null;
    this.stage = null;
    this.perf = 0;

    this.animate = function () {
      var start = performance.now();
      _this.renderer.render(_this.stage);
      var timeTaken = performance.now() - start;
      if (timeTaken > 10) console.log('redraw took longer than 10ms', timeTaken);
      // requestAnimationFrame(this.animate);
    };

    this.updatePages = function () {
      var page = _this.store.page;
      var pageTextures = _this.pageTextures;

      // No need to update if the page stayed the same

      if (pageTextures.width === page.width && pageTextures.height === page.height && pageTextures.amount === page.amount) {
        return;
      }

      console.log('updatePages');

      pageTextures.pages = {};
      pageTextures.width = page.width;
      pageTextures.height = page.height;
      pageTextures.amount = page.amount;

      // Create textures for each page
      if (page.amount <= 0) return;

      for (var i = 1; i <= page.amount; i++) {
        pageTextures.pages[i] = {};
        pageTextures.pages[i].texture = (0, _pageGraphics2.default)(_this.renderer, page, i, PAGE_COLOR, PAGE_TEXT_COLOR);
        pageTextures.pages[i].hoverTexture = (0, _pageGraphics2.default)(_this.renderer, page, i, PAGE_HOVER_COLOR, PAGE_TEXT_COLOR);
      }
    };

    this.updateSignature = function () {
      console.log('updateSignature');
      var start = performance.now();

      var signature = _this.store.signature;
      var pageTextures = _this.pageTextures,
          pagesContainer = _this.pagesContainer;


      pagesContainer.removeChildren();
      pagesContainer.width = signature.width;
      pagesContainer.height = signature.height;
      pagesContainer.position.set(signature.x, signature.y);

      _this.updatePages();

      if (pageTextures.amount > 0) {
        signature.pages.map(function (page) {
          return new _Page2.default(_this.animate, pageTextures.pages[page.pageNr], pagesContainer, page);
        });
      } else {
        _this.renderError(pagesContainer, "Amount of pages is invalid");
      }

      var timeTaken = performance.now() - start;
      console.log('creating data for new signature took', timeTaken);

      _this.animate();
    };

    this.renderError = function (container, error) {
      var errorText = new PIXI.Text(error);
      errorText.anchor.set(0.5);
      errorText.position.set(_this.store.sheet.width / 2, _this.store.sheet.height / 2);
      container.addChild(errorText);
    };

    this.store = store;
    var sheet = store.sheet,
        canvas = store.canvas;

    this.renderer = new PIXI.autoDetectRenderer(sheet.width, sheet.height, {
      transparent: false,
      backgroundColor: 0xFF00FF,
      antialias: true
    });

    this.stage = new PIXI.Container();
    this.stage.width = sheet.width;
    this.stage.height = sheet.height;
    this.stage.scale.set(canvas.scale);
    this.renderer.render(this.stage);

    new _Sheet2.default(this.animate, this.stage, store);

    this.stage.addChild(this.pagesContainer);

    this.animate();

    (0, _mobx.autorun)(function () {
      var _store$canvas = store.canvas,
          width = _store$canvas.width,
          height = _store$canvas.height,
          scale = _store$canvas.scale;

      _this.renderer.resize(width, height);
      _this.stage.scale.set(scale);
    });

    (0, _mobx.autorun)(this.updateSignature);
  }

  (0, _createClass3.default)(RendererStore, [{
    key: 'setContainer',
    value: function setContainer(container) {
      this.container = container;
      container.appendChild(this.renderer.view);
    }
  }]);
  return RendererStore;
}();

exports.default = RendererStore;

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

var _mobx = __webpack_require__(20);

var _helpers = __webpack_require__(979);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SHEET_COLOR = 0xD98E55;
var SIDE_COLOR = 0x7B4922;
var SIDE_HOVER_COLOR = 0x4D2B10;

var Sheet = (_class = function Sheet(animate, stage, store) {
  var _this = this;

  (0, _classCallCheck3.default)(this, Sheet);
  this.animate = null;
  this.stage = null;
  this.store = null;
  this.sheetGraphics = new PIXI.Graphics();
  this.sideGraphics = {
    left: new PIXI.Graphics(),
    right: new PIXI.Graphics(),
    top: new PIXI.Graphics(),
    bottom: new PIXI.Graphics()
  };

  _initDefineProp(this, 'sheetFillColor', _descriptor, this);

  _initDefineProp(this, 'sidesFillColors', _descriptor2, this);

  this.createSheet = function () {
    _this.stage.addChild(_this.sheetGraphics);
    _this.createSideGraphics();
  };

  this.createSideGraphics = function () {
    var _loop = function _loop(side) {
      if (_this.sideGraphics.hasOwnProperty(side)) {
        _this.sideGraphics[side].interactive = true;
        _this.sideGraphics[side].on('mouseover', function () {
          return _this.setSideGraphicsFillColor(side, SIDE_HOVER_COLOR);
        });
        _this.sideGraphics[side].on('mouseout', function () {
          return _this.setSideGraphicsFillColor(side, SIDE_COLOR);
        });
        _this.stage.addChild(_this.sideGraphics[side]);
      }
    };

    for (var side in _this.sideGraphics) {
      _loop(side);
    }
  };

  this.updateSheetGraphics = function () {
    // console.log('updateSheetGraphics');
    var sheet = _this.store.sheet;

    _this.sheetGraphics.clear().beginFill(_this.sheetFillColor, 1).drawRect(0, 0, sheet.width, sheet.height).endFill();
    _this.animate();
  };

  this.updateSideGraphics = function () {
    // console.log('updateSideGraphics');
    var sheet = _this.store.sheet;

    _this.sideGraphics.top.clear().beginFill(_this.sidesFillColors.top).drawRect(0, 0, sheet.width, sheet.top).endFill();

    _this.sideGraphics.right.clear().beginFill(_this.sidesFillColors.right).drawRect(sheet.width - sheet.right, 0, sheet.right, sheet.height).endFill();

    _this.sideGraphics.bottom.clear().beginFill(_this.sidesFillColors.bottom).drawRect(0, sheet.height - sheet.bottom, sheet.width, sheet.bottom).endFill();

    _this.sideGraphics.left.clear().beginFill(_this.sidesFillColors.left).drawRect(0, 0, sheet.left, sheet.height).endFill();
    _this.animate();
  };

  _initDefineProp(this, 'setSideGraphicsFillColor', _descriptor3, this);

  _initDefineProp(this, 'setFillColor', _descriptor4, this);

  this.stage = stage;
  this.store = store;
  this.animate = animate;

  this.createSheet();

  (0, _mobx.autorun)(this.updateSheetGraphics);
  (0, _mobx.autorun)(this.updateSideGraphics);
}
// @observable sheet = {
//   width: 0,
//   height: 0
// };
, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'sheetFillColor', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return SHEET_COLOR;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'sidesFillColors', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      top: SIDE_COLOR,
      right: SIDE_COLOR,
      bottom: SIDE_COLOR,
      left: SIDE_COLOR
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'setSideGraphicsFillColor', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (sideGraphicName, color) {
      _this2.sidesFillColors[sideGraphicName] = color;
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'setFillColor', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (color) {
      _this3.sheetFillColor = color;
    };
  }
})), _class);
exports.default = Sheet;

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRandomHexColor = exports.flattenObjectToArray = undefined;

var _typeof2 = __webpack_require__(198);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenObjectToArray = exports.flattenObjectToArray = function flattenObjectToArray(ob) {
  var toReturn = [];

  for (var i in ob) {
    if (!ob.hasOwnProperty(i)) continue;

    if ((0, _typeof3.default)(ob[i]) == 'object') {
      var flatObject = flattenObjectToArray(ob[i]);
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn.push(flatObject[x]);
      }
    } else {
      toReturn.push(ob[i]);
    }
  }
  return toReturn;
};

var getRandomHexColor = exports.getRandomHexColor = function getRandomHexColor() {
  var colors = [Math.floor(Math.random() * 255), Math.floor(Math.random() * 255), Math.floor(Math.random() * 255)];
  return (colors[0] << 16) + (colors[1] << 8) + colors[2];
};

/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _class, _temp, _initialiseProps;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = (_temp = _class = function Page(animate, textures, stage, page) {
  (0, _classCallCheck3.default)(this, Page);

  _initialiseProps.call(this);

  this.texture = textures.texture;
  this.hoverTexture = textures.hoverTexture;
  this.pageTexture = new PIXI.Sprite(textures.texture);
  this.stage = stage;
  this.page = page;
  this.animate = animate;

  this.createPage();
}, _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.pageTexture = null;
  this.stage = null;
  this.page = null;
  this.texture = null;
  this.hoverTexture = null;
  this.animate = null;

  this.createPage = function () {
    var stage = _this.stage,
        page = _this.page,
        texture = _this.texture,
        pageTexture = _this.pageTexture,
        hoverTexture = _this.hoverTexture;

    var rotation = page.rotation * Math.PI / 180;

    pageTexture.interactive = true;
    pageTexture.position.set(page.x, page.y);
    pageTexture.pivot.set(page.width / 2, page.height / 2);
    pageTexture.rotation = rotation;
    pageTexture.on('mouseover', function () {
      return _this.setTexture(hoverTexture);
    });
    pageTexture.on('mouseout', function () {
      return _this.setTexture(texture);
    });
    stage.addChild(pageTexture);
  };

  this.setTexture = function (texture) {
    _this.pageTexture.texture = texture;
    _this.animate();
  };
}, _temp);
exports.default = Page;

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pageGraphics;
function pageGraphics(renderer, page, pageNr, fillColor, textColor) {
  var width = page.width,
      height = page.height;

  var pageTexture = new PIXI.Graphics().beginFill(fillColor, 1).drawRect(0, 0, width, height).endFill().lineStyle(1, textColor, 1).moveTo(width / 5, height / 5).lineTo(width - width / 5, height / 5).moveTo(width / 2, height / 5).lineTo(width / 2, height / 3);

  var pageText = new PIXI.Text(pageNr, {
    fontSize: Math.min(Math.max(Math.min(width, height) / 1.8, 1), 24)
  });
  pageText.anchor.set(0.5);
  pageText.x = width / 2;
  pageText.y = height / 2;

  pageTexture.addChild(pageText);

  return renderer.generateTexture(pageTexture);
}

/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor;

var _mobx = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var WhiteSpaceStore = (_class = function () {
  //@observable value = 'exactly|5';

  function WhiteSpaceStore(brochureSettings) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "title";
    (0, _classCallCheck3.default)(this, WhiteSpaceStore);
    this.brochureSettings = null;
    this.title = null;

    _initDefineProp(this, 'setValue', _descriptor, this);

    this.brochureSettings = brochureSettings;
    this.title = title;
  }

  (0, _createClass3.default)(WhiteSpaceStore, [{
    key: 'whiteSpace',
    get: function get() {
      return WhiteSpaceStore.toJson(this.brochureSettings[this.title]);
    }
  }, {
    key: 'type',
    get: function get() {
      return this.whiteSpace.type;
    }
  }], [{
    key: 'toJson',
    value: function toJson(str) {
      var arr = str.split('|');
      switch (arr[0]) {
        case 'exactly':
          return {
            type: 'exactly',
            value: arr[1]
          };
        case 'between':
          return {
            type: 'between',
            from: arr[1],
            to: arr[2]
          };
        case 'relativeTo':
          return {
            type: 'relativeTo',
            relativeTo: arr[1],
            relativeToType: arr[2],
            value: arr[3]
          };
        default:
          return {
            type: 'exactly',
            value: 0
          };
      }
    }
  }]);
  return WhiteSpaceStore;
}(), (_applyDecoratedDescriptor(_class.prototype, 'whiteSpace', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'whiteSpace'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'type'), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, 'setValue', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this = this;

    return function (val) {
      console.log('setValue', val);
      switch (val.type) {
        case 'exactly':
          _this.brochureSettings[_this.title] = val.type + '|' + val.value;
          break;
        case 'between':
          _this.brochureSettings[_this.title] = val.type + '|' + val.from + '|' + val.to;
          break;
        case 'relativeTo':
          _this.brochureSettings[_this.title] = val.type + '|' + val.relativeTo + '|' + val.relativeToType + '|' + val.value;
          break;
        case 'new':
          _this.brochureSettings[_this.title] = '' + val.value;
      }
    };
  }
})), _class);
exports.default = WhiteSpaceStore;

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(67);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(68);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(17);

var _mobx = __webpack_require__(20);

var _styles = __webpack_require__(984);

var _styles2 = _interopRequireDefault(_styles);

var _SheetCalculatorStore = __webpack_require__(212);

var _SheetCalculatorStore2 = _interopRequireDefault(_SheetCalculatorStore);

var _reactMeasure = __webpack_require__(986);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

__webpack_require__(991);

var _WhiteSpaceForm = __webpack_require__(992);

var _WhiteSpaceForm2 = _interopRequireDefault(_WhiteSpaceForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SheetCalculator = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(SheetCalculator, _Component);
  (0, _createClass3.default)(SheetCalculator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.store.rendererStore.setContainer(this.pixiContainer);
    }
  }]);

  function SheetCalculator() {
    (0, _classCallCheck3.default)(this, SheetCalculator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SheetCalculator.__proto__ || Object.getPrototypeOf(SheetCalculator)).call(this));

    _this.store = null;
    _this.pixiContainer = null;

    _this.handleSheetWidthUpdate = function (event) {
      return _this.store.update('sheet', 'width', event.target.value);
    };

    _this.handleSheetHeightUpdate = function (event) {
      return _this.store.update('sheet', 'height', event.target.value);
    };

    _this.handleSheetBottomUpdate = function (event) {
      return _this.store.update('sheet', 'bottom', event.target.value);
    };

    _this.handleSheetTopUpdate = function (event) {
      return _this.store.update('sheet', 'top', event.target.value);
    };

    _this.handleSheetLeftUpdate = function (event) {
      return _this.store.update('sheet', 'left', event.target.value);
    };

    _this.handleSheetRightUpdate = function (event) {
      return _this.store.update('sheet', 'right', event.target.value);
    };

    _this.handlePageWidthUpdate = function (event) {
      return _this.store.update('page', 'width', event.target.value);
    };

    _this.handlePageHeightUpdate = function (event) {
      return _this.store.update('page', 'height', event.target.value);
    };

    _this.handlePageAmountUpdate = function (event) {
      return _this.store.update('page', 'amount', event.target.value);
    };

    _this.handleBleedHorizontalUpdate = function (event) {
      return _this.store.updateBleed('horizontal', event.target.value);
    };

    _this.handleBleedVerticalUpdate = function (event) {
      return _this.store.updateBleed('vertical', event.target.value);
    };

    _this.handleCanvasWidthUpdate = function (contentRect) {
      return _this.store.updateCanvasWidth(contentRect.bounds.width);
    };

    _this.handleTypeRadioChange = function (event) {
      return _this.store.updateType(event.target.value);
    };

    _initDefineProp(_this, 'handleSetSheet', _descriptor, _this);

    _this.store = new _SheetCalculatorStore2.default();
    return _this;
  }

  (0, _createClass3.default)(SheetCalculator, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _store = this.store,
          canvas = _store.canvas,
          sheet = _store.sheet,
          page = _store.page,
          bleed = _store.bleed,
          fits = _store.fits,
          options = _store.options;

      var canvasWidth = canvas.width;
      var canvasHeight = canvasWidth * sheet.height / sheet.width;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactMeasure2.default,
          { bounds: true, onResize: this.handleCanvasWidthUpdate },
          function (_ref) {
            var measureRef = _ref.measureRef;
            return _react2.default.createElement(
              'div',
              { ref: measureRef },
              _react2.default.createElement('div', { width: canvasWidth, height: canvasHeight, ref: function ref(div) {
                  return _this2.pixiContainer = div;
                } })
            );
          }
        ),
        _react2.default.createElement(
          'h5',
          null,
          'Sheet'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.handleSetSheet(640, 460, 15, 10, 5, 5);
              } },
            'KBA 640x460'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.handleSetSheet(640, 450, 15, 10, 5, 5);
              } },
            'KBA 640x450'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.handleSetSheet(720, 520, 15, 10, 5, 5);
              } },
            'KBA 720x520'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.handleSetSheet(720, 510, 15, 10, 5, 5);
              } },
            'KBA 720x510'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.handleSetSheet(458, 318, 5, 5, 5, 5);
              } },
            'DIGI 458x318'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.handleSetSheet(488, 330, 5, 5, 5, 5);
              } },
            'DIGI 488x330'
          ),
          _react2.default.createElement(_WhiteSpaceForm2.default, { options: this.store.brochureWhiteSpaces.top }),
          _react2.default.createElement(
            'p',
            null,
            'Width: ',
            _react2.default.createElement('input', { type: 'number', onChange: this.handleSheetWidthUpdate, value: sheet.width }),
            'mm'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Height: ',
            _react2.default.createElement('input', { type: 'number', onChange: this.handleSheetHeightUpdate, value: sheet.height }),
            'mm'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Bottom: ',
            _react2.default.createElement('input', { onChange: this.handleSheetBottomUpdate, value: sheet.bottom }),
            'mm'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Top: ',
            _react2.default.createElement('input', { type: 'number', onChange: this.handleSheetTopUpdate, value: sheet.top }),
            'mm'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Left: ',
            _react2.default.createElement('input', { type: 'number', onChange: this.handleSheetLeftUpdate, value: sheet.left }),
            'mm'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Right: ',
            _react2.default.createElement('input', { type: 'number', onChange: this.handleSheetRightUpdate, value: sheet.right }),
            'mm'
          ),
          _react2.default.createElement(
            'fieldset',
            null,
            _react2.default.createElement(
              'legend',
              null,
              'Kuidas tr\xFCkime?'
            ),
            _react2.default.createElement('input', {
              type: 'radio',
              name: 'type',
              value: _SheetCalculatorStore.sheetTypeEnum.SHEETWISE,
              checked: options.type === _SheetCalculatorStore.sheetTypeEnum.SHEETWISE,
              onChange: this.handleTypeRadioChange
            }),
            'P/S',
            _react2.default.createElement('br', null),
            _react2.default.createElement('input', {
              type: 'radio',
              name: 'type',
              value: _SheetCalculatorStore.sheetTypeEnum.WORK_AND_TURN,
              checked: options.type === _SheetCalculatorStore.sheetTypeEnum.WORK_AND_TURN,
              onChange: this.handleTypeRadioChange
            }),
            '\xDC/V',
            _react2.default.createElement('br', null),
            _react2.default.createElement('input', {
              type: 'radio',
              name: 'type',
              value: _SheetCalculatorStore.sheetTypeEnum.WORK_AND_TUMBLE,
              checked: options.type === _SheetCalculatorStore.sheetTypeEnum.WORK_AND_TUMBLE,
              onChange: this.handleTypeRadioChange
            }),
            '\xDC/P',
            _react2.default.createElement('br', null)
          )
        ),
        _react2.default.createElement(
          'h5',
          null,
          'Page'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Width: ',
            _react2.default.createElement('input', { type: 'number', onChange: this.handlePageWidthUpdate, value: page.width }),
            'mm'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Height: ',
            _react2.default.createElement('input', { type: 'number', onChange: this.handlePageHeightUpdate, value: page.height }),
            'mm'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Amount: ',
            _react2.default.createElement('input', { type: 'number', onChange: this.handlePageAmountUpdate, value: page.amount }),
            'mm'
          )
        ),
        _react2.default.createElement(
          'h5',
          null,
          'Bleeds, comma separated'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Horizontal(left to right): ',
            _react2.default.createElement('input', { onChange: this.handleBleedHorizontalUpdate, value: bleed.horizontal })
          ),
          _react2.default.createElement(
            'p',
            null,
            'Vertical(top to bottom): ',
            _react2.default.createElement('input', { onChange: this.handleBleedVerticalUpdate, value: bleed.vertical })
          )
        ),
        _react2.default.createElement(
          'h5',
          null,
          'Fits'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Fits: ',
            fits.total,
            ' ',
            fits.type,
            ' (',
            fits.horizontal,
            'x',
            fits.vertical,
            ')'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Wasted paper: ',
            Math.round((sheet.area - page.area * fits.total) * 100 / sheet.area * 100) / 100,
            '%'
          )
        )
      );
    }
  }]);
  return SheetCalculator;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'handleSetSheet', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (width, height, bottom, top, left, right) {
      _this3.store.update('sheet', 'width', width);
      _this3.store.update('sheet', 'height', height);
      _this3.store.update('sheet', 'bottom', bottom);
      _this3.store.update('sheet', 'top', top);
      _this3.store.update('sheet', 'left', left);
      _this3.store.update('sheet', 'right', right);
    };
  }
})), _class2)) || _class;

exports.default = SheetCalculator;

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(985);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _SheetCalculatorStore = __webpack_require__(212);

function minimumComposedSize(type, page) {
  if (!page || !page.width || !page.height) return null;
  switch (type) {
    case 'brochure':
      return {
        width: page.width * 2,
        height: page.height,
        horizontalBleed: 0,
        whitespace: {
          top: 5,
          bottom: 5,
          right: 5,
          left: 15
        }
      };
    default:
      return {
        width: page.width,
        height: page.height
      };
  }
}

function shuffleForHalfFold(pages) {
  var numberOfPages = pages.length;
  if (!numberOfPages || numberOfPages % 4 !== 0) return console.error('number of pages is wrong for halfFold');
  var numberOfGroups = numberOfPages / 4;

  var result = [];

  for (var i = 0; i < numberOfGroups; i++) {
    var firstPage = i * 2;
    var lastPage = numberOfPages - 1 - i * 2;
    result.push({
      width: 0,
      height: 0,
      top: 5,
      bottom: 5,
      right: 5,
      left: 15,

      front: [pages[lastPage], pages[firstPage]],
      back: [pages[firstPage + 1], pages[lastPage - 1]]
    });
  }

  console.log(JSON.stringify(result));

  return result;
}

// container = {width: number, height: number, type: sheetTypeEnum}
// bleeds = {horizontal: number || [numbers], vertical: number || [numbers]}
// size = {width: number, height: number}
function fits(container, bleeds, size) {
  var workAndTurn = container.type === _SheetCalculatorStore.sheetTypeEnum.WORK_AND_TURN;
  var workAndTumble = container.type === _SheetCalculatorStore.sheetTypeEnum.WORK_AND_TUMBLE;
  var minimumComposedSize = minimumComposedSize('brochure', size);
  var upright = {
    horizontal: fitsAxis(container.width)
  };
}

function fitsAxis(containerWidth, pageWidth, bleeds, shouldBeEven) {
  if (pageWidth > containerWidth) return 0;
  var currentBleed = typeof bleeds === 'number' ? bleeds : 0;
  var currentWidth = pageWidth;
  var i = 1;
  while (currentWidth <= containerWidth) {
    if (Array.isArray(bleeds)) currentBleed = bleeds[i - 1] || 0;

    currentWidth += pageWidth + bleeds[bleedIndex];
    if (currentWidth <= sheetWidth) i++;
  }
  if (shouldBeEven && i % 2 !== 0) return i - 1;
  return i;
}

/*
@computed get fits() {
  let workAndTurn = this.store.options.type === sheetTypeEnum.WORK_AND_TURN;
  let workAndTumble = this.store.options.type === sheetTypeEnum.WORK_AND_TUMBLE;
  const upright = {
    horizontal: this.fitsAxis(this.sheet.printable.width, this.page.width, this.bleed.asArray.horizontal, workAndTurn),
    vertical: this.fitsAxis(this.sheet.printable.height, this.page.height, this.bleed.asArray.vertical, workAndTumble)
  };
  const rotated = {
    horizontal: this.fitsAxis(this.sheet.printable.width, this.page.height, this.bleed.asArray.horizontal, workAndTurn),
    vertical: this.fitsAxis(this.sheet.printable.height, this.page.width, this.bleed.asArray.vertical, workAndTumble)
  };
  if (upright.horizontal * upright.vertical >= rotated.horizontal * rotated.vertical) {
    return {
      type: 'upright',
      horizontal: upright.horizontal,
      vertical: upright.vertical,
      total: upright.horizontal * upright.vertical
    };
  } else {
    return {
      type: 'rotated',
      horizontal: rotated.horizontal,
      vertical: rotated.vertical,
      total: rotated.horizontal * rotated.vertical
    };
  }
}
*/

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WhiteSpaceForm(_ref) {
  var options = _ref.options;

  var typeSelect = {};
  var exactlyInput = {};
  var betweenFromInput = {};
  var betweenToInput = {};
  var relativitySelect = {};
  var relativitySubSelect = null;
  var relativityInput = {};

  var renderBasedOnSelection = function renderBasedOnSelection(selection) {
    switch (selection) {
      case 'exactly':
        return _react2.default.createElement('input', {
          type: 'number',
          placeholder: 'exactly',
          value: options.whiteSpace.value,
          onChange: handleExactlyChange,
          ref: function ref(el) {
            return exactlyInput = el;
          }
        });
      case 'between':
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('input', {
            type: 'number',
            placeholder: 'from',
            value: options.whiteSpace.from,
            onChange: handleBetweenChange,
            ref: function ref(el) {
              return betweenFromInput = el;
            }
          }),
          _react2.default.createElement('input', {
            type: 'number',
            placeholder: 'to',
            value: options.whiteSpace.to,
            onChange: handleBetweenChange,
            ref: function ref(el) {
              return betweenToInput = el;
            }
          })
        );
      case 'relativeTo':
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'select',
            {
              value: options.whiteSpace.relativeTo,
              onChange: handleRelativeToChange,
              ref: function ref(el) {
                return relativitySelect = el;
              }
            },
            _react2.default.createElement(
              'option',
              { value: '---' },
              '---'
            ),
            Object.keys(options.brochureSettings).filter(function (key) {
              return key !== options.title;
            }).map(function (key) {
              return _react2.default.createElement(
                'option',
                { key: key, value: key },
                key
              );
            })
          ),
          _react2.default.createElement(
            'select',
            {
              value: options.whiteSpace.relativeToType,
              onChange: handleRelativeToChange,
              ref: function ref(el) {
                return relativitySubSelect = el;
              }
            },
            _react2.default.createElement(
              'option',
              { value: '---' },
              '---'
            ),
            _react2.default.createElement(
              'option',
              { value: 'smallerBy' },
              'Smaller By'
            ),
            _react2.default.createElement(
              'option',
              { value: 'largerBy' },
              'Larger By'
            ),
            _react2.default.createElement(
              'option',
              { value: 'equal' },
              'Equal'
            )
          ),
          _react2.default.createElement('input', {
            type: 'number',
            placeholder: options.whiteSpace.relativeToType,
            value: options.whiteSpace.value,
            onChange: handleRelativeToChange,
            ref: function ref(el) {
              return relativityInput = el;
            }
          })
        );
      default:
        return _react2.default.createElement(
          'p',
          null,
          'FAIL'
        );
    }
  };

  var handleExactlyChange = function handleExactlyChange() {
    options.setValue({
      type: typeSelect.value,
      value: exactlyInput.value
    });
  };

  var handleBetweenChange = function handleBetweenChange() {
    options.setValue({
      type: typeSelect.value,
      from: betweenFromInput.value,
      to: betweenToInput.value
    });
  };

  var handleRelativeToChange = function handleRelativeToChange() {
    options.setValue({
      type: typeSelect.value,
      relativeTo: relativitySelect.value,
      relativeToType: relativitySubSelect.value,
      value: relativityInput.value
    });
  };

  var handleTypeChange = function handleTypeChange(e) {
    options.setValue({
      type: 'new',
      value: e.target.value
    });
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'select',
      {
        value: options.whiteSpace.type,
        onChange: handleTypeChange,
        ref: function ref(el) {
          return typeSelect = el;
        }
      },
      _react2.default.createElement(
        'option',
        { value: 'exactly' },
        'Exactly'
      ),
      _react2.default.createElement(
        'option',
        { value: 'between' },
        'Between'
      ),
      _react2.default.createElement(
        'option',
        { value: 'relativeTo' },
        'relativeTo'
      )
    ),
    renderBasedOnSelection(options.whiteSpace.type)
  );
}

exports.default = (0, _mobxReact.observer)(WhiteSpaceForm);

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Imposer = __webpack_require__(994);

var _Imposer2 = _interopRequireDefault(_Imposer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Imposer2.default;

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(67);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(68);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(518);

var _styles2 = _interopRequireDefault(_styles);

var _mobxReact = __webpack_require__(17);

var _ImposerStore = __webpack_require__(996);

var _ImposerStore2 = _interopRequireDefault(_ImposerStore);

var _Page = __webpack_require__(1042);

var _Page2 = _interopRequireDefault(_Page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Imposer = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Imposer, _Component);

  function Imposer() {
    (0, _classCallCheck3.default)(this, Imposer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Imposer.__proto__ || Object.getPrototypeOf(Imposer)).call(this));

    _this.store = null;

    _this.handleFileInputChange = function (e) {
      return _this.store.addFiles(e.target.files);
    };

    _this.handleRemoveFile = function (index) {
      return _this.store.removeFile(index);
    };

    _this.store = new _ImposerStore2.default();

    return _this;
  }

  (0, _createClass3.default)(Imposer, [{
    key: 'render',
    value: function render() {
      console.log('RENDERING!');
      var store = this.store,
          handleFileInputChange = this.handleFileInputChange,
          handleRemoveFile = this.handleRemoveFile;

      return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Imposer'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('input', { type: 'file', onChange: handleFileInputChange, accept: '.pdf', multiple: true })
        ),
        _react2.default.createElement(
          'div',
          null,
          store.files.map(function (file, index) {
            return _react2.default.createElement(
              'div',
              { className: _styles2.default.fileContainer, key: index },
              _react2.default.createElement(
                'h1',
                null,
                file.name
              ),
              _react2.default.createElement(
                'div',
                { className: _styles2.default.pagesContainer },
                file.pages.map(function (page) {
                  return _react2.default.createElement(_Page2.default, { key: page.pageIndex, page: page });
                })
              )
            );
          })
        )
      );
    }
  }]);
  return Imposer;
}(_react.Component)) || _class;

exports.default = Imposer;

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".styles--fileContainer--Zz75wupK {\r\n  background-color: #DDD;\r\n  border: 2px solid black;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.styles--fileContainer--Zz75wupK > h1 {\r\n  background-color: #BBB;\r\n  padding: 1rem;\r\n  line-height: 1rem;\r\n  margin: 0;\r\n}\r\n\r\n.styles--pagesContainer--1jsz3qzT {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  overflow-x: auto;\r\n  padding: 0.5rem;\r\n  min-height: 150px;\r\n}\r\n\r\n.styles--page--21AsPqGk {\r\n  border: 1px solid black;\r\n  margin: 0.1rem;\r\n  min-height: 150px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"fileContainer": "styles--fileContainer--Zz75wupK",
	"pagesContainer": "styles--pagesContainer--1jsz3qzT",
	"page": "styles--page--21AsPqGk"
};

/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor;

var _mobx = __webpack_require__(20);

var _FileStore = __webpack_require__(997);

var _FileStore2 = _interopRequireDefault(_FileStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImposerStore = (_class = function () {
  function ImposerStore() {
    (0, _classCallCheck3.default)(this, ImposerStore);

    _initDefineProp(this, 'files', _descriptor, this);
  }

  (0, _createClass3.default)(ImposerStore, [{
    key: 'addFiles',
    value: function addFiles(files) {
      console.log("incoming files", files.length, files);
      for (var i = 0; i < files.length; i++) {
        this.files.push(new _FileStore2.default(files[i]));
      }
    }
  }, {
    key: 'removeFile',
    value: function removeFile(index) {
      this.files.splice(index, 1);
    }
  }]);
  return ImposerStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'files', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'addFiles', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'addFiles'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeFile', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'removeFile'), _class.prototype)), _class);
exports.default = ImposerStore;

/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = __webpack_require__(998);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(1001);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(19);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(23);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2;

var _mobx = __webpack_require__(20);

var _computedAsyncMobx = __webpack_require__(1013);

var _webpack = __webpack_require__(523);

var _webpack2 = _interopRequireDefault(_webpack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var FileStore = (_class = function () {
  (0, _createClass3.default)(FileStore, [{
    key: 'pages',
    get: function get() {
      return this.pagesAsync.value;
    }
  }, {
    key: 'name',
    get: function get() {
      return this.file.name;
    }
  }]);

  function FileStore(file) {
    var _this = this;

    (0, _classCallCheck3.default)(this, FileStore);

    _initDefineProp(this, 'file', _descriptor, this);

    _initDefineProp(this, 'pdf', _descriptor2, this);

    this.pagesAsync = (0, _computedAsyncMobx.computedAsync)([], (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var pdf, result, i, page;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pdf = _this.pdf;
              result = [];
              i = 1;

            case 3:
              if (!(i <= pdf.pdfInfo.numPages)) {
                _context.next = 11;
                break;
              }

              _context.next = 6;
              return pdf.getPage(i);

            case 6:
              page = _context.sent;

              result.push(page);

            case 8:
              i++;
              _context.next = 3;
              break;

            case 11:
              return _context.abrupt('return', result);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    })));

    (0, _mobx.extendObservable)(this, { file: file });

    var fileReader = new FileReader();
    fileReader.onload = function (event) {
      _webpack2.default.getDocument(fileReader.result).then((0, _mobx.action)(function (pdf) {
        (0, _mobx.extendObservable)(_this, { pdf: pdf });
      }));
    };
    fileReader.readAsArrayBuffer(file);
  }

  return FileStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'file', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'pdf', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'pages', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'pages'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'name', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'name'), _class.prototype)), _class);
exports.default = FileStore;

/***/ })

},[542]);


// WEBPACK FOOTER //
// app.904c8ae3419999d6dbb0.js